import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Footer from "./Footer";
import Header from "./Header";
import WebsiteDevelopmentIco1 from "./assets/img/WebsiteDevelopmentIco-1.png";
import WebsiteDevelopmentIco2 from "./assets/img/WebsiteDevelopmentIco-2.png";
import WebsiteDevelopmentIco3 from "./assets/img/WebsiteDevelopmentIco-3.png";
import WebsiteDevelopmentIco4 from "./assets/img/WebsiteDevelopmentIco-4.png";
import WebsiteDevelopmentIco5 from "./assets/img/WebsiteDevelopmentIco-5.png";
import WebsiteDevelopmentIco6 from "./assets/img/WebsiteDevelopmentIco-6.png";
import WebsiteDevelopmentIco7 from "./assets/img/WebsiteDevelopmentIco-7.png";
import seoIco1 from "./assets/img/seoIco-1.png";
import seoIco2 from "./assets/img/seoIco-2.png";
import seoIco3 from "./assets/img/seoIco-3.png";
import seoIco4 from "./assets/img/seoIco-4.png";
import seoIco5 from "./assets/img/seoIco-5.png";
import seoIco6 from "./assets/img/seoIco-6.png";
import seoIco7 from "./assets/img/seoIco-7.png";
import seoIco8 from "./assets/img/seoIco-8.png";
import SocialMediaIco1 from "./assets/img/SocialMediaIco-1.png";
import SocialMediaIco3 from "./assets/img/SocialMediaIco-3.png";
import SocialMediaIco4 from "./assets/img/SocialMediaIco-4.png";
import SocialMediaIco5 from "./assets/img/SocialMediaIco-5.png";
import SocialMediaIco6 from "./assets/img/SocialMediaIco-6.png";
import SocialMediaIco7 from "./assets/img/SocialMediaIco-7.png";
import SocialMediaIco8 from "./assets/img/SocialMediaIco-8.png";
import CustomerEngIco1 from "./assets/img/CustomerEngIco-1.png";
import CustomerEngIco2 from "./assets/img/CustomerEngIco-2.png";
import CustomerEngIco3 from "./assets/img/CustomerEngIco-3.png";
import CustomerEngIco4 from "./assets/img/CustomerEngIco-4.png";
import CustomerEngIco5 from "./assets/img/CustomerEngIco-5.png";
import CustomerEngIco6 from "./assets/img/CustomerEngIco-6.png";
import CustomerEngIco7 from "./assets/img/CustomerEngIco-7.png";
import CustomerEngIco8 from "./assets/img/CustomerEngIco-8.png";
import CMSIco1 from "./assets/img/CMSIco-1.png";
import CMSIco2 from "./assets/img/CMSIco-2.png";
import CMSIco3 from "./assets/img/CMSIco-3.png";
import CMSIco4 from "./assets/img/CMSIco-4.png";
import CMSIco5 from "./assets/img/CMSIco-5.png";
import CMSIco6 from "./assets/img/CMSIco-6.png";
import CMSIco9 from "./assets/img/CMSIco-9.png";
import WorkflowAutoIco1 from "./assets/img/WorkflowAutoIco-1.png";
import WorkflowAutoIco2 from "./assets/img/WorkflowAutoIco-2.png";
import WorkflowAutoIco3 from "./assets/img/WorkflowAutoIco-3.png";
import WorkflowAutoIco4 from "./assets/img/WorkflowAutoIco-4.png";
import WorkflowAutoIco5 from "./assets/img/WorkflowAutoIco-5.png";
import WorkflowAutoIco6 from "./assets/img/WorkflowAutoIco-6.png";
import caseStudyIco1 from "./assets/img/caseStudyIco-1.png";
import DedicatedTeamsImg3 from "./assets/img/DedicatedTeamsImg-3.png";
const DigitalTransformationDtls = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const initialSection = splitLocation[1] || "aiPowered";

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        {(initialSection === "websiteDevelopment" ||
          pathname === "/DigitalTransformation") && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Website Development</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap commonCotentWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <p>
                        At Hummingtec, we understand that building a website is
                        more than just coding – it's about bringing your digital
                        vision to life. Our comprehensive website development
                        process ensures that every site we create is not only
                        visually stunning but also functionally robust and
                        user-friendly. Here’s how we do it:
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Discovery and Planning</h2>
                              <ul>
                                <li>
                                  <strong>Understanding Your Vision : </strong>{" "}
                                  We begin by understanding your business goals,
                                  target audience, and desired website
                                  functionality.
                                </li>
                                <li>
                                  <strong>Strategic Planning : </strong> Our
                                  team drafts a project plan, outlining
                                  timelines, deliverables, and milestones.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Design and Prototyping</h2>
                              <ul>
                                <li>
                                  <strong>Creative Design : </strong> Our
                                  designers craft visually appealing designs,
                                  focusing on user experience and brand
                                  alignment.
                                </li>
                                <li>
                                  <strong>Interactive Prototypes : </strong> We
                                  create interactive prototypes, allowing you to
                                  see and feel the website's layout and
                                  functionality before development begins.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Development</h2>
                              <ul>
                                <li>
                                  <strong>Front-End Development : </strong> Our
                                  developers bring designs to life with
                                  responsive and interactive front-end
                                  development.
                                </li>
                                <li>
                                  <strong>Back-End Development : </strong> We
                                  build robust back-end systems to support
                                  website functionality, including databases,
                                  content management systems, and server-side
                                  processes.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Content Integration</h2>
                              <ul>
                                <li>
                                  <strong>Compelling Content : </strong> Our
                                  content team develops engaging and
                                  SEO-friendly content that resonates with your
                                  audience.
                                </li>
                                <li>
                                  <strong>Seamless Integration : </strong>{" "}
                                  Content is integrated into the website,
                                  ensuring a cohesive and immersive user
                                  experience.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco5}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Testing and Quality Assurance</h2>
                              <ul>
                                <li>
                                  <strong>Rigorous Testing : </strong> We
                                  conduct thorough testing, covering usability,
                                  performance, and security aspects.
                                </li>
                                <li>
                                  <strong>Feedback Incorporation : </strong>{" "}
                                  Your feedback is vital. We make necessary
                                  revisions to ensure the website meets your
                                  expectations.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco6}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Launch and Optimization</h2>
                              <ul>
                                <li>
                                  <strong>Smooth Launch : </strong> Once
                                  everything is polished and approved, we launch
                                  your website to the public.
                                </li>
                                <li>
                                  <strong>Continuous Optimization : </strong>{" "}
                                  Post-launch, we monitor performance and user
                                  engagement, making optimizations to improve
                                  effectiveness.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco7}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Maintenance and Support</h2>
                              <ul>
                                <li>
                                  <strong>Ongoing Support : </strong> We offer
                                  continuous support and maintenance to ensure
                                  your website stays updated and secure.
                                </li>
                                <li>
                                  <strong>Future Enhancements : </strong> As
                                  your business evolves, we’re here to make sure
                                  your website does too, with ongoing
                                  enhancements and feature additions.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap benefitsDigiWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Why Partner with Hummingtec Solutions?</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#6cdc99"
                                      opacity="1"
                                      data-original="#6cdc99"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0h-312.839v-492H74.142v407.853z"
                                    transform="translate(375.349 502)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0h74.142L0 84.147Z"
                                    transform="translate(375.349 417.853)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0c-30.038 17.947-50.151 50.785-50.151 88.314 0 56.78 46.029 102.81 102.809 102.81 56.78 0 102.81-46.03 102.81-102.81 0-12.596-2.266-24.665-6.412-35.818"
                                    transform="translate(203.342 269.815)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0c0-23.597-19.129-42.725-42.726-42.725-23.596 0-42.725 19.128-42.725 42.725 0 23.596 19.129 42.725 42.725 42.725C-19.129 42.725 0 23.596 0 0Z"
                                    transform="translate(298.726 380.647)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v-51.336c-15.404-9.208-33.416-14.496-52.658-14.496-19.242 0-37.254 5.288-52.658 14.496V0c0 9.263 7.5 16.772 16.763 16.772h71.789C-7.501 16.772 0 9.263 0 0Z"
                                    transform="translate(308.658 321.15)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 12.105-19.763 22.536-5.405-15.055-17.62 1.823-23.104L0-57.019l-21.41-8.873 1.823 23.104-15.054 17.62 22.536 5.405z"
                                    transform="translate(153.005 217.922)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 12.105-19.763 22.536-5.405-15.054-17.62 1.822-23.104L0-57.019l-21.409-8.873 1.823 23.104-15.055 17.62 22.536 5.405z"
                                    transform="translate(256 217.922)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 12.104-19.763 22.537-5.405-15.055-17.62 1.823-23.104L0-57.019l-21.41-8.873 1.823 23.104-15.055 17.62 22.537 5.405z"
                                    transform="translate(358.995 217.922)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v0"
                                    transform="translate(347.497 110)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h144.156"
                                    transform="translate(164.502 110)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h275.271"
                                    transform="translate(118.364 65.203)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Expertise and Experience</h2>
                            <p>
                              Our team of digital transformation experts brings
                              a wealth of knowledge and hands-on experience
                              across various industries.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M28.5 24H1c-.6 0-1-.5-1-1v-6.4c0-2.8 2.3-5.2 5.2-5.2h26.7c.6 0 1 .5 1 1s-.5 1-1 1H5.1c-1.7 0-3.1 1.4-3.1 3.1v5.4h26.5c.6 0 1 .5 1 1s-.4 1.1-1 1.1z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M5.1 61c-1.4 0-2.7-.5-3.6-1.5-1-1-1.5-2.3-1.5-3.7V22.9c0-.6.5-1 1-1h27.5c.6 0 1 .5 1 1s-.5 1-1 1H2v31.8c0 .8.3 1.6.9 2.2s1.4.9 2.2.9H52c1.7 0 3.1-1.4 3.1-3.1v-20c0-.6.5-1 1-1s1 .5 1 1v20c0 2.8-2.3 5.2-5.2 5.2H5.1zM9 18.7H6.8c-.6 0-1-.5-1-1s.5-1 1-1H9c.6 0 1 .5 1 1s-.4 1-1 1zM13.9 18.7h-2.2c-.6 0-1-.5-1-1s.5-1 1-1h2.2c.6 0 1 .5 1 1s-.4 1-1 1zM18.8 18.7h-2.2c-.6 0-1-.5-1-1s.5-1 1-1h2.2c.6 0 1 .5 1 1s-.4 1-1 1z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M24.6 42.1H10c-1.7 0-3.1-1.4-3.1-3.1v-8.7c0-1.7 1.4-3.1 3.1-3.1h14.6c1.7 0 3.1 1.4 3.1 3.1V39c0 1.7-1.4 3.1-3.1 3.1zm0-12.9H10c-.6 0-1 .5-1 1V39c0 .6.5 1 1 1h14.6c.6 0 1-.5 1-1v-8.7c0-.6-.5-1.1-1-1.1zM35.1 35.9H34c-.6 0-1-.5-1-1s.5-1 1-1h1.1c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 42.5H34c-.6 0-1-.5-1-1s.5-1 1-1h15.8c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 49.1H7.4c-.6 0-1-.5-1-1s.5-1 1-1h42.4c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 55.7H7.4c-.6 0-1-.5-1-1s.5-1 1-1h42.4c.6 0 1 .5 1 1s-.5 1-1 1zM48.4 36.3h-1.6c-1.3 0-2.4-1-2.6-2.2l-.4-2.5c0-.2-.2-.3-.3-.4-.4-.1-.7-.3-1.1-.4-.2-.1-.3-.1-.5 0l-2 1.5c-1 .7-2.5.6-3.4-.3l-1.2-1.2c-.9-.9-1-2.3-.3-3.4l1.5-2c.1-.2.1-.4 0-.5-.2-.3-.3-.7-.5-1.1-.1-.2-.2-.3-.4-.3l-2.4-.4c-1.3-.2-2.2-1.3-2.2-2.6v-1.7c0-1.3.9-2.4 2.2-2.6l2.4-.4c.2 0 .3-.2.4-.3.1-.4.3-.7.5-1.1.1-.2.1-.4 0-.5l-1.5-2c-.8-1-.6-2.4.2-3.4l1.2-1.2c.9-.9 2.4-1 3.4-.2l1.9 1.5c.2.2.4.1.5 0 .4-.2.7-.3 1.1-.5.2-.1.3-.2.4-.4l.4-2.5C44.4 4 45.5 3 46.8 3h1.6c1.3 0 2.4 1 2.6 2.2l.4 2.5c0 .2.2.3.3.4.4.1.7.3 1.1.4.2.1.3.1.5 0l2-1.5c1-.8 2.5-.6 3.4.3l1.2 1.2c.9.9 1 2.3.3 3.4l-1.5 2c-.1.2-.1.4 0 .5.2.3.3.7.5 1.1.1.2.2.3.4.3l2.4.4c1.3.2 2.2 1.3 2.2 2.6v1.7c0 1.3-.9 2.4-2.2 2.6l-2.4.4c-.2 0-.3.2-.4.3-.1.4-.3.7-.4 1.1-.1.2-.1.4 0 .6l1.5 2c.7 1 .6 2.4-.2 3.4L58.6 32c-.9.9-2.4 1-3.4.2l-1.9-1.5c-.2-.2-.4-.1-.5 0-.4.2-.7.3-1.1.5-.2.1-.3.2-.3.4l-.4 2.5c-.2 1.2-1.3 2.2-2.6 2.2zm-6.3-7.7c.4 0 .8.1 1.1.3.3.1.6.3.9.4.9.3 1.5 1.1 1.7 2l.4 2.5c0 .3.3.5.5.5h1.6c.3 0 .5-.2.5-.4l.4-2.5c.1-.9.8-1.7 1.7-2 .3-.1.6-.2.9-.4.8-.4 1.9-.3 2.7.3l2 1.5c.3.2.5.1.7-.1l1.2-1.2c.2-.2.2-.5 0-.7l-1.5-2c-.6-.8-.7-1.8-.3-2.6.1-.3.3-.6.4-.9.3-.9 1.1-1.6 2-1.7l2.4-.4c.3 0 .4-.3.4-.5V19c0-.3-.2-.5-.4-.5l-2.4-.4c-.9-.1-1.7-.8-2-1.7-.1-.3-.2-.6-.4-.9-.4-.9-.3-1.9.2-2.7l1.5-2c.2-.2.1-.5 0-.7l-1.2-1.2c-.1-.1-.3-.2-.4-.2s-.2 0-.3.1l-1.9 1.5c-.7.6-1.8.7-2.7.3-.3-.1-.6-.3-.9-.4-.9-.3-1.5-1.1-1.7-2l-.4-2.5c0-.3-.3-.5-.5-.5h-1.6c-.3 0-.5.2-.5.4L45.9 8c-.1.9-.8 1.7-1.7 2-.3.1-.6.2-.9.4-.8.4-1.9.3-2.7-.3l-2-1.5c-.3-.3-.5-.1-.7.1l-1.2 1.2c-.2.2-.2.5 0 .7l1.5 2c.5.8.6 1.8.2 2.6-.1.3-.3.6-.4.9-.3.9-1.1 1.6-2 1.7l-2.4.4c-.3 0-.4.3-.4.5v1.7c0 .3.2.5.4.5l2.4.4c.9.1 1.7.8 2 1.7.1.3.2.6.4.9.4.9.3 1.9-.3 2.7l-1.5 2c-.2.2-.1.5 0 .7l1.2 1.2c.2.2.4.3.7.1l2-1.5c.5-.3 1.1-.5 1.6-.5z"
                                  fill="#67a9d5"
                                  opacity="0.45"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M47.6 26.3a6.7 6.7 0 1 1 0-13.4 6.7 6.7 0 0 1 0 13.4zm0-11.3C45 15 43 17.1 43 19.6c0 2.6 2.1 4.6 4.6 4.6s4.6-2.1 4.6-4.6-2.1-4.6-4.6-4.6z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Customized Solutions</h2>
                            <p>
                              We understand that one size does not fit all. Our
                              approach is to tailor solutions that specifically
                              address your unique challenges and opportunities.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="m61.12 38.24-1.941-.48a28 28 0 1 0-54.358 0l-1.941.48a30 30 0 1 1 58.24 0z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M14.027 35.008a1.04 1.04 0 0 1-.651-.227 5.7 5.7 0 0 1-1.619-3.427 1.489 1.489 0 0 1 .747-1.222c.769-.439 2.261-.4 4.742-.19.3.027.546.05.69.056a4.624 4.624 0 0 0 2.108-2.292c.614-2 3.1-4.518 5.546-5.618A8.928 8.928 0 0 1 29.774 21c.819-.825 2.051-4.523 1.413-5.418-.411-.574-1.925-1.16-3.143-1.631-1.882-.728-3.507-1.357-3.979-2.594s.017-3.9.656-6.98c.133-.645.259-1.253.285-1.486a1 1 0 1 1 1.988.22c-.036.328-.153.891-.315 1.671-.287 1.385-1.049 5.064-.744 5.863.181.416 1.905 1.083 2.831 1.441 1.692.654 3.29 1.272 4.047 2.334 1.235 1.727.056 5.108-.74 6.655C31.4 22.388 30.738 23 30 23h-.194a6.823 6.823 0 0 0-3.4.913 9.083 9.083 0 0 0-4.454 4.382C21.391 30.133 19.178 32 18 32c-.156 0-.492-.026-.928-.064a23.945 23.945 0 0 0-3.251-.126 5.636 5.636 0 0 0 .848 1.448.974.974 0 0 1 .135 1.386.989.989 0 0 1-.777.364zM6 36.727a.989.989 0 0 1-.227-.026 7.083 7.083 0 0 1-2.163-.773 1.031 1.031 0 0 1-.477-1.358.974.974 0 0 1 1.312-.47c.049.025.1.054.164.09a5.277 5.277 0 0 0 1.617.558A1 1 0 0 1 6 36.727zM45.78 25.058a3.569 3.569 0 0 1-1.474-.412C43.765 24.389 42 23.438 42 22c0-.348.01-.8.021-1.281.019-.84.044-1.968 0-2.479l-.048-.035A2.307 2.307 0 0 1 41 15.932l.031-.457.369-.275c.183-.137 4.544-3.345 9.047-1.095l.1.057a6.258 6.258 0 0 1 1.519 2.055c.261.445.531.905.74 1.189a1.266 1.266 0 0 1 .2 1.086c-.255.944-1.492 1.611-4.352 2.841-.43.185-.966.415-1.091.492l-.059.036a3.731 3.731 0 0 0-.249 1.2 2.341 2.341 0 0 1-.625 1.712 1.3 1.3 0 0 1-.85.285zM43.057 16.5a1 1 0 0 0 .132.113 1.828 1.828 0 0 1 .8 1.247 24.719 24.719 0 0 1 .03 2.9c-.011.464-.021.9-.021 1.235a3.277 3.277 0 0 0 1.263.89v-.038c.1-.9.227-2.134 1.207-2.7a11.175 11.175 0 0 1 1.39-.652 25.48 25.48 0 0 0 2.973-1.436c-.161-.258-.327-.541-.5-.834a11.809 11.809 0 0 0-.883-1.379c-2.648-1.261-5.348.033-6.391.654zm4.436 5.365-.016.01zM32 47a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM43 61a1 1 0 0 1-1-1v-7a3 3 0 0 0-3-3H25a3 3 0 0 0-3 3v7a1 1 0 0 1-2 0v-7a5.006 5.006 0 0 1 5-5h14a5.006 5.006 0 0 1 5 5v7a1 1 0 0 1-1 1zM12 52a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM1 61a1 1 0 0 1-1-1v-2a5.006 5.006 0 0 1 5-5h13a1 1 0 0 1 0 2H5a3 3 0 0 0-3 3v2a1 1 0 0 1-1 1zM52 52a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM63 61a1 1 0 0 1-1-1v-2a3 3 0 0 0-3-3H46a1 1 0 0 1 0-2h13a5.006 5.006 0 0 1 5 5v2a1 1 0 0 1-1 1z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Collaborative Partnership</h2>
                            <p>
                              We work as an extension of your team, ensuring
                              seamless communication and alignment with your
                              business objectives.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M51.464 41.328A9.234 9.234 0 0 0 48.88 41a9.57 9.57 0 0 0-2.345.331 1 1 0 0 0-.742.967l-.007.998a7.643 7.643 0 0 0-1.131.63.133.133 0 0 1-.1-.016l-.863-.482a1.001 1.001 0 0 0-1.177.148 8.936 8.936 0 0 0-2.482 4.162 1 1 0 0 0 .479 1.131l.9.503a6.813 6.813 0 0 0 0 1.256l-.9.503a1 1 0 0 0-.479 1.13 8.927 8.927 0 0 0 2.477 4.165 1.001 1.001 0 0 0 1.177.149l.868-.485a.139.139 0 0 1 .098-.018 12.114 12.114 0 0 0 1.14.666v.968a1 1 0 0 0 .742.966 9.563 9.563 0 0 0 2.47.328h.113a9.57 9.57 0 0 0 2.345-.331 1 1 0 0 0 .742-.967l.007-.998a7.643 7.643 0 0 0 1.131-.63.133.133 0 0 1 .1.016l.863.483a.998.998 0 0 0 1.177-.15 8.937 8.937 0 0 0 2.482-4.16 1 1 0 0 0-.479-1.132l-.9-.503a6.813 6.813 0 0 0 0-1.256l.9-.503a1 1 0 0 0 .479-1.131 8.933 8.933 0 0 0-2.477-4.164 1.001 1.001 0 0 0-1.177-.149l-.868.485a.148.148 0 0 1-.098.018 12.149 12.149 0 0 0-1.14-.666v-.968a1 1 0 0 0-.742-.966Zm.763 4.257a2.115 2.115 0 0 0 2.192.071l.19-.106a6.923 6.923 0 0 1 1.185 1.974l-.78.435a1 1 0 0 0-.494 1.06 4.968 4.968 0 0 1 0 1.961 1 1 0 0 0 .495 1.06l.779.436a6.937 6.937 0 0 1-1.188 1.972l-.188-.105a2.107 2.107 0 0 0-2.191.072 5.642 5.642 0 0 1-.836.465 2.034 2.034 0 0 0-1.185 1.858v.16a7.186 7.186 0 0 1-1.112.101 7.11 7.11 0 0 1-1.3-.1v-.161a2.034 2.034 0 0 0-1.185-1.858 5.65 5.65 0 0 1-.836-.466 2.111 2.111 0 0 0-2.192-.07l-.19.106a6.919 6.919 0 0 1-1.185-1.974l.78-.436a1 1 0 0 0 .494-1.06 4.968 4.968 0 0 1 0-1.96 1 1 0 0 0-.495-1.06l-.779-.436a6.937 6.937 0 0 1 1.189-1.972l.187.104a2.111 2.111 0 0 0 2.191-.071 5.642 5.642 0 0 1 .836-.465 2.034 2.034 0 0 0 1.185-1.858v-.16a7.186 7.186 0 0 1 1.112-.101 7.559 7.559 0 0 1 1.3.1v.161a2.034 2.034 0 0 0 1.185 1.858 5.601 5.601 0 0 1 .836.465Z"
                                  fill="#e2e283"
                                  opacity="1"
                                  data-original="#e2e283"
                                ></path>
                                <path
                                  d="M45 50a4 4 0 1 0 4-4 4.005 4.005 0 0 0-4 4Zm6 0a2 2 0 1 1-2-2 2.002 2.002 0 0 1 2 2ZM2 6v51a2.002 2.002 0 0 0 2 2h32v-2H4V6h14v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6h14v29h2V6a2.002 2.002 0 0 0-2-2H34a3.003 3.003 0 0 0-3-3H21a3.003 3.003 0 0 0-3 3H4a2.002 2.002 0 0 0-2 2Zm18-2a1.001 1.001 0 0 1 1-1h10a1.001 1.001 0 0 1 1 1v3H20Z"
                                  fill="#e2e283"
                                  opacity="1"
                                  data-original="#e2e283"
                                ></path>
                                <path
                                  d="M15 46a1 1 0 0 0 1-1V26a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1Zm-4-19h3v17h-3ZM24 46a1 1 0 0 0 1-1V23a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1Zm-4-22h3v20h-3ZM33 46a1 1 0 0 0 1-1V28a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1Zm-4-17h3v15h-3ZM43 38V23a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v19h2V24h3v14Z"
                                  fill="#e2e283"
                                  opacity="0.45"
                                  data-original="#e2e283"
                                ></path>
                                <path
                                  d="m43.553 13.105-13.499 6.75-7.524-4.703a1.002 1.002 0 0 0-.881-.088l-16 6 .702 1.872L21.89 17.11l7.581 4.738a1.005 1.005 0 0 0 .977.047l14-7ZM6 48h29v2H6zM62 50q0-.547-.044-1.083l-1.994.165Q60 49.537 60 50q0 .464-.038.917l1.994.165Q62 50.548 62 50ZM49 37a12.993 12.993 0 0 0-12.59 9.75l1.936.5a11.004 11.004 0 0 1 21.308 0l1.936-.5A12.993 12.993 0 0 0 49 37ZM38.038 50.917Q38 50.463 38 50q0-.464.038-.917l-1.994-.165Q36 49.452 36 50q0 .547.044 1.083ZM49 63a12.993 12.993 0 0 0 12.59-9.75l-1.936-.5a11.004 11.004 0 0 1-21.308 0l-1.936.5A12.993 12.993 0 0 0 49 63Z"
                                  fill="#e2e283"
                                  opacity="0.45"
                                  data-original="#e2e283"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Outcome-Focused</h2>
                            <p>
                              Your success is our success. We're committed to
                              delivering measurable results that impact your
                              bottom line.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="whyHumingtecSec">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Transform Your Business with Hummingtec Solutions</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="dataWrap">
                      <p>
                        Embrace the digital future confidently with Hummingtec
                        Solutions. Our digital transformation services are your
                        gateway to becoming a more agile, efficient, and
                        innovative organization. Ready to embark on a
                        transformative journey? Contact us today to explore how
                        we can elevate your business in the digital age.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "ProcessDiscovery" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Process Discovery & Digital Blueprinting</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "DataMigration" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Data Migration & Task Automation</h2>
                      <p>
                        Seamlessly Move Your Data. Effortlessly Automate Your
                        Workflows.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Overview</h2>
                      <p>
                        Are you still relying on scattered spreadsheets,
                        outdated tools, or disconnected systems? Our{" "}
                        <strong>Data Migration & Task Automation</strong>{" "}
                        service helps you consolidate, streamline, and elevate
                        your operations by moving your legacy data to robust
                        cloud-based platforms—while automating repetitive,
                        manual processes that slow your team down.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Data Migration</h2>
                      <p>
                        We ensure a smooth and secure transition of your
                        historical and current data from:
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Excel/Google Sheets
                        </li>
                        <li>
                          <strong>2. </strong> Legacy desktop systems
                        </li>
                        <li>
                          <strong>3. </strong> Local databases
                        </li>
                        <li>
                          <strong>4. </strong> Other third-party software
                        </li>
                      </ul>
                      <p>
                        <strong>Key features:</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Data validation and cleansing</span>
                        <span>Format transformation</span>
                        <span>Schema mapping</span>
                        <span>Error handling and rollback mechanisms</span>
                        <span>Migration testing and verification</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Task Automation</h2>
                      <p>
                        Manual tasks are prone to error and delay. We automate
                        your routine operations such as:
                      </p>
                      <ul>
                        <li>
                          <strong>1. </strong> Report generation
                        </li>
                        <li>
                          <strong>2. </strong> Email and notification workflows
                        </li>
                        <li>
                          <strong>3. </strong> Approval processes
                        </li>
                        <li>
                          <strong>4. </strong> Data entry and syncing between
                          systems
                        </li>
                        <li>
                          <strong>5. </strong> KPI tracking and alerts
                        </li>
                      </ul>
                      <p>
                        Automation tools we use include custom scripts,
                        no-code/low-code platforms, and advanced workflow
                        engines depending on your scale and need.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>How It Helps Your Business</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M472 16H312a24.028 24.028 0 0 0-24 24v96a24.028 24.028 0 0 0 24 24h36.687l13.656 13.657a8 8 0 0 0 11.314 0L387.313 160H472a24.028 24.028 0 0 0 24-24V40a24.028 24.028 0 0 0-24-24zm8 120a8.009 8.009 0 0 1-8 8h-88a8 8 0 0 0-5.657 2.343L368 156.687l-10.343-10.344A8 8 0 0 0 352 144h-40a8.009 8.009 0 0 1-8-8V40a8.009 8.009 0 0 1 8-8h160a8.009 8.009 0 0 1 8 8z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M376 56h-32v16h12.686l-34.343 34.343 11.314 11.314L368 83.314V96h16V64a8 8 0 0 0-8-8zM400 48h64v16h-64zM400 80h64v16h-64zM400 112h64v16h-64zM424 408a40.045 40.045 0 0 0 40-40V184h-16v144H64V128a24.028 24.028 0 0 1 24-24h184V88H88a40.045 40.045 0 0 0-40 40v240a40.045 40.045 0 0 0 40 40h99.867l-17.143 40H136a24 24 0 0 0 0 48h240a24 24 0 0 0 0-48h-34.724l-17.143-40zM64 368v-24h384v24a24.028 24.028 0 0 1-24 24H88a24.028 24.028 0 0 1-24-24zm320 104a8.009 8.009 0 0 1-8 8H136a8 8 0 0 1 0-16h240a8.009 8.009 0 0 1 8 8zm-60.133-24H188.133l17.143-40h101.448z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M248 360h16v16h-16zM88 144v152a8 8 0 0 0 8 8h160v-16h-24v-96h-16v96h-16v-64h-16v64h-16v-80h-16v80h-16v-48h-16v48h-16V144zM416 192H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h120a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-112 16h64v16h-64zm104 16h-24v-16h24zM416 304a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm-8-16h-72v-16h72zm-104-16h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M120 208h16v16h-16zM152 176h16v16h-16zM184 192h16v16h-16zM216 160h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Reduced Human Error</h2>
                            <p>
                              Automated workflows ensure consistency and
                              accuracy.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M19.869 207v135c0 5.523 4.477 10 10 10H49.8c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.779c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.78c2.968-27.649 26.369-49.182 54.807-49.182s51.839 21.533 54.807 49.182h19.931c5.523 0 10-4.477 10-10V52.069H19.869V172M390 19.46H17.5c-5.523 0-10 4.477-10 10v12.609c0 5.523 4.477 10 10 10h477c5.523 0 10-4.477 10-10V29.46c0-5.523-4.477-10-10-10H425M408 492.54h69.131c8.284 0 15-6.716 15-15v-26.82a29.978 29.978 0 0 0-17.588-27.297l-39.362-17.864c-8.161 4.774-17.651 7.522-27.788 7.522s-19.627-2.748-27.788-7.522l-39.362 17.864a29.906 29.906 0 0 0-8.547 5.857 29.963 29.963 0 0 1 9.041 21.44v41.82H373M171.756 423.423l-39.362-17.864a54.854 54.854 0 0 1-27.788 7.522 54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v26.82c0 8.284 6.716 15 15 15h136.393v-41.82a29.963 29.963 0 0 1 9.041-21.44 29.888 29.888 0 0 0-8.546-5.857z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="m323.15 423.423-39.362-17.864A54.854 54.854 0 0 1 256 413.081a54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v41.82h169.476v-41.82a29.976 29.976 0 0 0-17.588-27.297z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <circle
                                  cx="407.394"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 407.387 357.94)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="104.607"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 104.606 357.942)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="256"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 255.996 357.941)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <path
                                  d="M189.729 148.02a5 5 0 0 1-5-5v-26.866c-12.185-7.235-26.405-11.402-41.604-11.402-45.08 0-81.625 36.545-81.625 81.625s36.545 81.625 81.625 81.625 81.625-36.545 81.625-81.625c0-13.867-3.469-26.919-9.569-38.356h-25.452z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M224.749 186.375h-81.624v-81.624M292.172 148.02H189.729a5 5 0 0 1-5-5V98.047a5 5 0 0 1 5-5h102.443a5 5 0 0 1 5 5v44.972a5 5 0 0 1-5 5.001zM214.714 120.533h52.473M256.213 187.5h11.619M256.213 222.477h11.619M256.213 257.455h11.619M297.408 187.5H450.5M297.408 222.477H395.5M297.408 257.455H450.5M450.5 135.533h-61.364M389.136 105.533H450.5M417.5 222.477h33"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Time Savings</h2>
                            <p>
                              Free up your team from repetitive work to focus on
                              what matters.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 66 66"
                            >
                              <g>
                                <path
                                  d="M45.93 6.96h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 6.82c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 10.89h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 10.75c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 14.82h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 14.69c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM27.71 49.82h-3.98c-.48 0-.88.39-.88.88v8.39h-2.21V46.26c0-.48-.39-.88-.88-.88h-3.98c-.48 0-.88.39-.88.88v12.82h-2.21V40.86c0-.48-.39-.88-.88-.88H7.86c-.48 0-.88.39-.88.88v18.23h-.44c-.48 0-.88.39-.88.88s.39.88.88.88h23.02c.48 0 .88-.39.88-.88s-.39-.88-.88-.88h-.97V50.7c0-.49-.39-.88-.88-.88zm-3.1 1.75h2.23v7.52h-2.23zm-7.94-4.43h2.23v11.95h-2.23zm-7.94-5.41h2.23v17.35H8.73zM47.43 45.12c4.37-4.37 4.37-11.49 0-15.86-2.12-2.12-4.93-3.28-7.93-3.28s-5.81 1.17-7.93 3.29-3.28 4.93-3.28 7.93c0 2.99 1.17 5.81 3.29 7.93s4.94 3.28 7.93 3.28 5.8-1.18 7.92-3.29zm-17.4-7.93c0-2.53.98-4.9 2.77-6.69s4.17-2.77 6.69-2.77c2.53 0 4.9.98 6.69 2.77 3.69 3.69 3.69 9.7 0 13.39a9.403 9.403 0 0 1-6.69 2.77c-2.53 0-4.91-.98-6.69-2.77a9.443 9.443 0 0 1-2.77-6.7z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="m63.23 55.37-7.93-7.93a2.807 2.807 0 0 0-.41-3.44l-1.21-1.21c.7-1.76 1.07-3.66 1.07-5.61 0-4.08-1.59-7.91-4.47-10.79-5.95-5.95-15.63-5.95-21.58 0a15.158 15.158 0 0 0-4.47 10.79c0 4.07 1.59 7.91 4.47 10.79 2.97 2.97 6.88 4.46 10.79 4.46 1.9 0 3.81-.36 5.6-1.07l1.22 1.22a2.799 2.799 0 0 0 3.44.41l7.93 7.93c.74.74 1.73 1.15 2.77 1.15s2.03-.41 2.77-1.15 1.15-1.73 1.15-2.77-.4-2.03-1.14-2.78zm-33.28-8.63c-2.55-2.55-3.96-5.94-3.96-9.55s1.4-7 3.96-9.55c2.55-2.55 5.94-3.96 9.55-3.96s7 1.41 9.55 3.96S53 33.58 53 37.19c0 1.91-.4 3.75-1.15 5.44-.01.02-.02.03-.02.05-.66 1.49-1.59 2.87-2.78 4.05A13.37 13.37 0 0 1 45 49.51c-.02.01-.04.02-.05.03-1.69.75-3.54 1.15-5.44 1.15-3.62 0-7.01-1.4-9.56-3.95zm17.6 4.61-.77-.77a14.78 14.78 0 0 0 3.5-2.61c1.05-1.05 1.92-2.23 2.61-3.49l.76.76a1.06 1.06 0 0 1 0 1.5l-.15.15-4.3 4.31-.14.14c-.4.41-1.1.41-1.51.01zm14.44 8.33c-.82.82-2.25.82-3.07 0l-7.86-7.86 3.07-3.07 7.86 7.86c.41.41.64.96.64 1.54s-.23 1.12-.64 1.53z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M40.37 44.09v-.67c1.57-.39 2.74-1.81 2.74-3.49 0-1.99-1.62-3.61-3.61-3.61-1.03 0-1.86-.84-1.86-1.86s.84-1.86 1.86-1.86 1.86.84 1.86 1.86c0 .48.39.88.88.88s.88-.39.88-.88c0-1.69-1.17-3.1-2.74-3.49v-.67c0-.48-.39-.88-.88-.88s-.88.39-.88.88v.67c-1.57.39-2.74 1.81-2.74 3.49 0 1.99 1.62 3.61 3.61 3.61 1.03 0 1.86.84 1.86 1.86 0 1.03-.84 1.86-1.86 1.86s-1.86-.84-1.86-1.86c0-.48-.39-.88-.88-.88s-.88.39-.88.88c0 1.69 1.17 3.1 2.74 3.49v.67c0 .48.39.88.88.88s.88-.4.88-.88zM25.74 17.29h-8.22V9.08c0-.48-.39-.88-.88-.88-5.5 0-9.97 4.47-9.97 9.97s4.47 9.97 9.97 9.97 9.97-4.47 9.97-9.97a.88.88 0 0 0-.87-.88zm-9.1 9.1c-4.53 0-8.22-3.69-8.22-8.22 0-4.24 3.22-7.73 7.34-8.17v8.17c0 .48.39.88.88.88h8.17c-.43 4.12-3.93 7.34-8.17 7.34z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M29.64 15.14c0-5.5-4.47-9.97-9.97-9.97-.48 0-.88.39-.88.88v9.09c0 .48.39.88.88.88h9.09c.49-.01.88-.4.88-.88zm-9.09-.88v-7.3c3.83.41 6.89 3.46 7.3 7.3z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M50.37 55.29c-.48 0-.88.39-.88.88v3.8c0 1.75-1.42 3.17-3.17 3.17H6.54c-1.75 0-3.17-1.42-3.17-3.17V6.04c0-1.75 1.42-3.17 3.17-3.17h39.79c1.75 0 3.17 1.42 3.17 3.17v16.32c0 .48.39.88.88.88s.88-.39.88-.88V6.04a4.93 4.93 0 0 0-4.92-4.92H6.54a4.93 4.93 0 0 0-4.92 4.92v53.92a4.93 4.93 0 0 0 4.92 4.92h39.79a4.93 4.93 0 0 0 4.92-4.92v-3.8a.886.886 0 0 0-.88-.87z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Data Integrity</h2>
                            <p>
                              Ensure that historical records and operational
                              data are structured and usable.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M421.713 263.57V244.5c0-33.137-26.863-60-60-60h-40c-33.137 0-60 26.863-60 60v19.07"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M301.713 263.57V244.5c0-11.046 8.954-20 20-20h40c11.046 0 20 8.954 20 20v19.07M181.713 314.077v151.791c0 21.336 17.296 38.632 38.632 38.632h242.736c21.336 0 38.632-17.296 38.632-38.632V314.077M388.506 386.834h-93.577"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M242.963 386.687c-34.208-2.275-61.25-30.743-61.25-65.527v-18.028c0-21.336 17.296-38.632 38.632-38.632h242.736c21.336 0 38.632 17.296 38.632 38.632v18.028c0 34.632-26.807 63.004-60.803 65.496"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M243.777 502.5v-133c0-13.807 11.193-25 25-25h0c13.807 0 25 11.193 25 25v133M389.649 455.884V502.5M439.649 502.5v-133c0-13.807-11.193-25-25-25h0c-13.807 0-25 11.193-25 25v51.235M279.269 296.729v11.999M404.158 296.729v11.999M325.25 308.371c4.003 4.593 9.892 7.5 16.463 7.5 6.571 0 12.46-2.907 16.463-7.5M83.23 55.695C118.902 25.622 164.978 7.5 215.287 7.5c113.218 0 205 91.782 205 205 0 4.286-.132 8.541-.391 12.762M180.319 414.529C83.758 397.934 10.287 313.797 10.287 212.5c0-50.433 18.211-96.612 48.417-132.32"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="m386.431 188.935-8.489-16.021a64.72 64.72 0 0 0-95.608-21.779l-18.121 13.368c-9.564 7.055-22.875 6.81-31.805-1.032-9.789-8.597-11.347-23.217-3.661-33.672l12.28-16.705a71.313 71.313 0 0 0 5.713-75.326h0a71.045 71.045 0 0 0-10.452-14.904A71.507 71.507 0 0 0 217.933 8.4M38.64 312.726c13.061 1.073 25.711-5.783 31.821-17.706l28.285-55.196a29.473 29.473 0 0 1 11.113-11.864v0a29.487 29.487 0 0 1 15.754-4.176h0c15.005.313 27.371 11.839 28.758 26.758.959 10.313 6.747 19.658 15.997 24.317 6.184 3.115 12.187 4.25 17.854 4.046M289.764 23.49l13.071 34.297c19.719 51.74 69.852 48.839 85.562 48.844M180.684 351.222a54.999 54.999 0 0 1-14.702 2.805 55.028 55.028 0 0 1-27.54-5.716c-21.271-10.635-46.473-5.08-61.471 12.13"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Scalability</h2>
                            <p>
                              Lay the groundwork for advanced analytics, AI
                              forecasting, and system integrations.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M32 48a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM44 61a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3s-11 1.982-11 3v6a1 1 0 0 1-2 0v-6c0-3.283 6.54-5 13-5s13 1.717 13 5v6a1 1 0 0 1-1 1ZM49 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M61 56a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3-4.1 0-7.9.715-9.9 1.866a1 1 0 1 1-1-1.732C40.425 44.8 44.5 44 49 44c6.46 0 13 1.717 13 5v6a1 1 0 0 1-1 1ZM15 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM3 56a1 1 0 0 1-1-1v-6c0-3.283 6.54-5 13-5 4.5 0 8.575.8 10.894 2.134a1 1 0 1 1-1 1.732C22.9 46.715 19.105 46 15 46c-7.117 0-11 1.982-11 3v6a1 1 0 0 1-1 1ZM32 24a1 1 0 0 1-.707-1.707L46.364 7.222a1 1 0 0 1 1.414 1.414L32.707 23.707A1 1 0 0 1 32 24Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M46 15a1.01 1.01 0 0 1-.243-.03l-4-1a1 1 0 0 1-.464-1.677l5-5a1 1 0 0 1 .95-.263l4 1a1 1 0 0 1 .464 1.677l-5 5A1 1 0 0 1 46 15Zm-2.044-2.542 1.737.435 3.351-3.351-1.737-.435Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M42 14a1.016 1.016 0 0 1-.267-.036 1 1 0 0 1-.7-.721l-1-4a1 1 0 0 1 .263-.95l5-5a1 1 0 0 1 1.677.464l1 4a1 1 0 0 1-.263.95l-5 5A1 1 0 0 1 42 14Zm.107-4.693.435 1.737 3.351-3.351-.435-1.737ZM15.115 26a1 1 0 0 1-.992-.884A18.429 18.429 0 0 1 14 23 18.009 18.009 0 0 1 39.412 6.592a1 1 0 0 1-.824 1.823A16.008 16.008 0 0 0 16 23a16.423 16.423 0 0 0 .109 1.884 1 1 0 0 1-.877 1.109.918.918 0 0 1-.117.007ZM48.885 26a.918.918 0 0 1-.117-.007 1 1 0 0 1-.877-1.109A16.423 16.423 0 0 0 48 23a15.87 15.87 0 0 0-1.415-6.588 1 1 0 0 1 1.823-.824A17.867 17.867 0 0 1 50 23a18.429 18.429 0 0 1-.123 2.116 1 1 0 0 1-.992.884ZM32 29a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M38.319 33a1 1 0 0 1-.577-1.818 10 10 0 1 0-11.484 0 1 1 0 1 1-1.152 1.636 12 12 0 1 1 13.788 0 1 1 0 0 1-.575.182Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Audit Trails & Logs</h2>
                            <p>
                              Every change and action is recorded for
                              transparency and compliance.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Real Results We've Delivered</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Migrated complex operational data
                          from 20+ spreadsheets into a centralized,
                          user-friendly database
                        </li>
                        <li>
                          <strong>2. </strong> Automated daily reports that used
                          to take teams hours, now generated in seconds
                        </li>
                        <li>
                          <strong>3. </strong> Replaced multi-step approval
                          processes with auto-routed, role-based workflows
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Our Approach</h2>
                      <ul>
                        <li>
                          <strong>1. Discovery & Assessment : </strong>We review
                          your current tools, formats, and workflows.
                        </li>
                        <li>
                          <strong>2. Design & Mapping : </strong>
                          Define what data goes where and what tasks need
                          automation.
                        </li>
                        <li>
                          <strong>3. Migration & Testing : </strong> Move,
                          transform, and validate data with minimal disruption.
                        </li>
                        <li>
                          <strong>4. Automation Integration : </strong>
                          Implement logic, workflows, and user roles.
                        </li>
                        <li>
                          <strong>5. Training & Handover : </strong> We onboard
                          your team and provide ongoing support.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="CommonBtmWrap">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-9">
                    <div className="dataWrap">
                      <h2>Let’s Upgrade Your Workflow</h2>
                      <p>
                        Stop spending hours on what software can do in seconds.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "RealTimeDashboards" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Real-Time Dashboards & Reporting</h2>
                      <p>Visualize. Monitor. Act – Instantly.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap commonCotentWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <h2>Overview</h2>
                      <p>
                        In today's fast-moving environments, businesses can’t
                        afford to wait for weekly reports or manual data
                        crunching. Our
                        <strong> Real-Time Dashboards & Reporting </strong>
                        service empowers you to make
                        <strong> informed decisions on the go </strong> with
                        <strong> live insights </strong>,
                        <strong> custom visualizations </strong>, and
                        <strong> automated reports </strong> tailored to your
                        operations.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Custom Dashboards</h2>
                              <ul>
                                <li>
                                  Built for different roles (Management,
                                  Operations, Finance, etc.)
                                </li>
                                <li>
                                  KPIs, trends, and actionable alerts in one
                                  view
                                </li>
                                <li>
                                  Drill-down capabilities for detailed
                                  exploration
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Live Data Feeds</h2>
                              <ul>
                                <li>
                                  Connects to your databases, spreadsheets,
                                  APIs, or IoT devices
                                </li>
                                <li>
                                  Updates dashboards in real time without manual
                                  refresh
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Automated Reporting</h2>
                              <ul>
                                <li>
                                  Daily/weekly/monthly reports delivered to
                                  inbox or app
                                </li>
                                <li>PDF, Excel, or interactive formats</li>
                                <li>
                                  Schedule-based or trigger-based (e.g. stock
                                  drop, missed target)
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Self-Service Tools</h2>
                              <ul>
                                <li>
                                  Build your own reports with drag-and-drop
                                  interfaces
                                </li>
                                <li>
                                  Apply filters, date ranges, and export as
                                  needed
                                </li>
                              </ul>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Benefits to Your Business</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M472 16H312a24.028 24.028 0 0 0-24 24v96a24.028 24.028 0 0 0 24 24h36.687l13.656 13.657a8 8 0 0 0 11.314 0L387.313 160H472a24.028 24.028 0 0 0 24-24V40a24.028 24.028 0 0 0-24-24zm8 120a8.009 8.009 0 0 1-8 8h-88a8 8 0 0 0-5.657 2.343L368 156.687l-10.343-10.344A8 8 0 0 0 352 144h-40a8.009 8.009 0 0 1-8-8V40a8.009 8.009 0 0 1 8-8h160a8.009 8.009 0 0 1 8 8z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M376 56h-32v16h12.686l-34.343 34.343 11.314 11.314L368 83.314V96h16V64a8 8 0 0 0-8-8zM400 48h64v16h-64zM400 80h64v16h-64zM400 112h64v16h-64zM424 408a40.045 40.045 0 0 0 40-40V184h-16v144H64V128a24.028 24.028 0 0 1 24-24h184V88H88a40.045 40.045 0 0 0-40 40v240a40.045 40.045 0 0 0 40 40h99.867l-17.143 40H136a24 24 0 0 0 0 48h240a24 24 0 0 0 0-48h-34.724l-17.143-40zM64 368v-24h384v24a24.028 24.028 0 0 1-24 24H88a24.028 24.028 0 0 1-24-24zm320 104a8.009 8.009 0 0 1-8 8H136a8 8 0 0 1 0-16h240a8.009 8.009 0 0 1 8 8zm-60.133-24H188.133l17.143-40h101.448z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M248 360h16v16h-16zM88 144v152a8 8 0 0 0 8 8h160v-16h-24v-96h-16v96h-16v-64h-16v64h-16v-80h-16v80h-16v-48h-16v48h-16V144zM416 192H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h120a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-112 16h64v16h-64zm104 16h-24v-16h24zM416 304a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm-8-16h-72v-16h72zm-104-16h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M120 208h16v16h-16zM152 176h16v16h-16zM184 192h16v16h-16zM216 160h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Instant Visibility</h2>
                            <p>
                              No more waiting for data teams or month-end
                              summaries. Get insights when it matters.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M19.869 207v135c0 5.523 4.477 10 10 10H49.8c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.779c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.78c2.968-27.649 26.369-49.182 54.807-49.182s51.839 21.533 54.807 49.182h19.931c5.523 0 10-4.477 10-10V52.069H19.869V172M390 19.46H17.5c-5.523 0-10 4.477-10 10v12.609c0 5.523 4.477 10 10 10h477c5.523 0 10-4.477 10-10V29.46c0-5.523-4.477-10-10-10H425M408 492.54h69.131c8.284 0 15-6.716 15-15v-26.82a29.978 29.978 0 0 0-17.588-27.297l-39.362-17.864c-8.161 4.774-17.651 7.522-27.788 7.522s-19.627-2.748-27.788-7.522l-39.362 17.864a29.906 29.906 0 0 0-8.547 5.857 29.963 29.963 0 0 1 9.041 21.44v41.82H373M171.756 423.423l-39.362-17.864a54.854 54.854 0 0 1-27.788 7.522 54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v26.82c0 8.284 6.716 15 15 15h136.393v-41.82a29.963 29.963 0 0 1 9.041-21.44 29.888 29.888 0 0 0-8.546-5.857z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="m323.15 423.423-39.362-17.864A54.854 54.854 0 0 1 256 413.081a54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v41.82h169.476v-41.82a29.976 29.976 0 0 0-17.588-27.297z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <circle
                                  cx="407.394"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 407.387 357.94)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="104.607"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 104.606 357.942)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="256"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 255.996 357.941)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <path
                                  d="M189.729 148.02a5 5 0 0 1-5-5v-26.866c-12.185-7.235-26.405-11.402-41.604-11.402-45.08 0-81.625 36.545-81.625 81.625s36.545 81.625 81.625 81.625 81.625-36.545 81.625-81.625c0-13.867-3.469-26.919-9.569-38.356h-25.452z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M224.749 186.375h-81.624v-81.624M292.172 148.02H189.729a5 5 0 0 1-5-5V98.047a5 5 0 0 1 5-5h102.443a5 5 0 0 1 5 5v44.972a5 5 0 0 1-5 5.001zM214.714 120.533h52.473M256.213 187.5h11.619M256.213 222.477h11.619M256.213 257.455h11.619M297.408 187.5H450.5M297.408 222.477H395.5M297.408 257.455H450.5M450.5 135.533h-61.364M389.136 105.533H450.5M417.5 222.477h33"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Data-Driven Decisions</h2>
                            <p>
                              Track KPIs and trends in real time to adapt
                              strategies on the fly.{" "}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 66 66"
                            >
                              <g>
                                <path
                                  d="M45.93 6.96h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 6.82c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 10.89h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 10.75c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 14.82h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 14.69c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM27.71 49.82h-3.98c-.48 0-.88.39-.88.88v8.39h-2.21V46.26c0-.48-.39-.88-.88-.88h-3.98c-.48 0-.88.39-.88.88v12.82h-2.21V40.86c0-.48-.39-.88-.88-.88H7.86c-.48 0-.88.39-.88.88v18.23h-.44c-.48 0-.88.39-.88.88s.39.88.88.88h23.02c.48 0 .88-.39.88-.88s-.39-.88-.88-.88h-.97V50.7c0-.49-.39-.88-.88-.88zm-3.1 1.75h2.23v7.52h-2.23zm-7.94-4.43h2.23v11.95h-2.23zm-7.94-5.41h2.23v17.35H8.73zM47.43 45.12c4.37-4.37 4.37-11.49 0-15.86-2.12-2.12-4.93-3.28-7.93-3.28s-5.81 1.17-7.93 3.29-3.28 4.93-3.28 7.93c0 2.99 1.17 5.81 3.29 7.93s4.94 3.28 7.93 3.28 5.8-1.18 7.92-3.29zm-17.4-7.93c0-2.53.98-4.9 2.77-6.69s4.17-2.77 6.69-2.77c2.53 0 4.9.98 6.69 2.77 3.69 3.69 3.69 9.7 0 13.39a9.403 9.403 0 0 1-6.69 2.77c-2.53 0-4.91-.98-6.69-2.77a9.443 9.443 0 0 1-2.77-6.7z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="m63.23 55.37-7.93-7.93a2.807 2.807 0 0 0-.41-3.44l-1.21-1.21c.7-1.76 1.07-3.66 1.07-5.61 0-4.08-1.59-7.91-4.47-10.79-5.95-5.95-15.63-5.95-21.58 0a15.158 15.158 0 0 0-4.47 10.79c0 4.07 1.59 7.91 4.47 10.79 2.97 2.97 6.88 4.46 10.79 4.46 1.9 0 3.81-.36 5.6-1.07l1.22 1.22a2.799 2.799 0 0 0 3.44.41l7.93 7.93c.74.74 1.73 1.15 2.77 1.15s2.03-.41 2.77-1.15 1.15-1.73 1.15-2.77-.4-2.03-1.14-2.78zm-33.28-8.63c-2.55-2.55-3.96-5.94-3.96-9.55s1.4-7 3.96-9.55c2.55-2.55 5.94-3.96 9.55-3.96s7 1.41 9.55 3.96S53 33.58 53 37.19c0 1.91-.4 3.75-1.15 5.44-.01.02-.02.03-.02.05-.66 1.49-1.59 2.87-2.78 4.05A13.37 13.37 0 0 1 45 49.51c-.02.01-.04.02-.05.03-1.69.75-3.54 1.15-5.44 1.15-3.62 0-7.01-1.4-9.56-3.95zm17.6 4.61-.77-.77a14.78 14.78 0 0 0 3.5-2.61c1.05-1.05 1.92-2.23 2.61-3.49l.76.76a1.06 1.06 0 0 1 0 1.5l-.15.15-4.3 4.31-.14.14c-.4.41-1.1.41-1.51.01zm14.44 8.33c-.82.82-2.25.82-3.07 0l-7.86-7.86 3.07-3.07 7.86 7.86c.41.41.64.96.64 1.54s-.23 1.12-.64 1.53z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M40.37 44.09v-.67c1.57-.39 2.74-1.81 2.74-3.49 0-1.99-1.62-3.61-3.61-3.61-1.03 0-1.86-.84-1.86-1.86s.84-1.86 1.86-1.86 1.86.84 1.86 1.86c0 .48.39.88.88.88s.88-.39.88-.88c0-1.69-1.17-3.1-2.74-3.49v-.67c0-.48-.39-.88-.88-.88s-.88.39-.88.88v.67c-1.57.39-2.74 1.81-2.74 3.49 0 1.99 1.62 3.61 3.61 3.61 1.03 0 1.86.84 1.86 1.86 0 1.03-.84 1.86-1.86 1.86s-1.86-.84-1.86-1.86c0-.48-.39-.88-.88-.88s-.88.39-.88.88c0 1.69 1.17 3.1 2.74 3.49v.67c0 .48.39.88.88.88s.88-.4.88-.88zM25.74 17.29h-8.22V9.08c0-.48-.39-.88-.88-.88-5.5 0-9.97 4.47-9.97 9.97s4.47 9.97 9.97 9.97 9.97-4.47 9.97-9.97a.88.88 0 0 0-.87-.88zm-9.1 9.1c-4.53 0-8.22-3.69-8.22-8.22 0-4.24 3.22-7.73 7.34-8.17v8.17c0 .48.39.88.88.88h8.17c-.43 4.12-3.93 7.34-8.17 7.34z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M29.64 15.14c0-5.5-4.47-9.97-9.97-9.97-.48 0-.88.39-.88.88v9.09c0 .48.39.88.88.88h9.09c.49-.01.88-.4.88-.88zm-9.09-.88v-7.3c3.83.41 6.89 3.46 7.3 7.3z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M50.37 55.29c-.48 0-.88.39-.88.88v3.8c0 1.75-1.42 3.17-3.17 3.17H6.54c-1.75 0-3.17-1.42-3.17-3.17V6.04c0-1.75 1.42-3.17 3.17-3.17h39.79c1.75 0 3.17 1.42 3.17 3.17v16.32c0 .48.39.88.88.88s.88-.39.88-.88V6.04a4.93 4.93 0 0 0-4.92-4.92H6.54a4.93 4.93 0 0 0-4.92 4.92v53.92a4.93 4.93 0 0 0 4.92 4.92h39.79a4.93 4.93 0 0 0 4.92-4.92v-3.8a.886.886 0 0 0-.88-.87z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Transparency & Accountability</h2>
                            <p>
                              Each department sees their numbers live – driving
                              ownership and performance.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M421.713 263.57V244.5c0-33.137-26.863-60-60-60h-40c-33.137 0-60 26.863-60 60v19.07"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M301.713 263.57V244.5c0-11.046 8.954-20 20-20h40c11.046 0 20 8.954 20 20v19.07M181.713 314.077v151.791c0 21.336 17.296 38.632 38.632 38.632h242.736c21.336 0 38.632-17.296 38.632-38.632V314.077M388.506 386.834h-93.577"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M242.963 386.687c-34.208-2.275-61.25-30.743-61.25-65.527v-18.028c0-21.336 17.296-38.632 38.632-38.632h242.736c21.336 0 38.632 17.296 38.632 38.632v18.028c0 34.632-26.807 63.004-60.803 65.496"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M243.777 502.5v-133c0-13.807 11.193-25 25-25h0c13.807 0 25 11.193 25 25v133M389.649 455.884V502.5M439.649 502.5v-133c0-13.807-11.193-25-25-25h0c-13.807 0-25 11.193-25 25v51.235M279.269 296.729v11.999M404.158 296.729v11.999M325.25 308.371c4.003 4.593 9.892 7.5 16.463 7.5 6.571 0 12.46-2.907 16.463-7.5M83.23 55.695C118.902 25.622 164.978 7.5 215.287 7.5c113.218 0 205 91.782 205 205 0 4.286-.132 8.541-.391 12.762M180.319 414.529C83.758 397.934 10.287 313.797 10.287 212.5c0-50.433 18.211-96.612 48.417-132.32"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="m386.431 188.935-8.489-16.021a64.72 64.72 0 0 0-95.608-21.779l-18.121 13.368c-9.564 7.055-22.875 6.81-31.805-1.032-9.789-8.597-11.347-23.217-3.661-33.672l12.28-16.705a71.313 71.313 0 0 0 5.713-75.326h0a71.045 71.045 0 0 0-10.452-14.904A71.507 71.507 0 0 0 217.933 8.4M38.64 312.726c13.061 1.073 25.711-5.783 31.821-17.706l28.285-55.196a29.473 29.473 0 0 1 11.113-11.864v0a29.487 29.487 0 0 1 15.754-4.176h0c15.005.313 27.371 11.839 28.758 26.758.959 10.313 6.747 19.658 15.997 24.317 6.184 3.115 12.187 4.25 17.854 4.046M289.764 23.49l13.071 34.297c19.719 51.74 69.852 48.839 85.562 48.844M180.684 351.222a54.999 54.999 0 0 1-14.702 2.805 55.028 55.028 0 0 1-27.54-5.716c-21.271-10.635-46.473-5.08-61.471 12.13"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Early Warning System</h2>
                            <p>
                              Identify issues before they escalate with alerts
                              and threshold triggers.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M32 48a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM44 61a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3s-11 1.982-11 3v6a1 1 0 0 1-2 0v-6c0-3.283 6.54-5 13-5s13 1.717 13 5v6a1 1 0 0 1-1 1ZM49 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M61 56a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3-4.1 0-7.9.715-9.9 1.866a1 1 0 1 1-1-1.732C40.425 44.8 44.5 44 49 44c6.46 0 13 1.717 13 5v6a1 1 0 0 1-1 1ZM15 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM3 56a1 1 0 0 1-1-1v-6c0-3.283 6.54-5 13-5 4.5 0 8.575.8 10.894 2.134a1 1 0 1 1-1 1.732C22.9 46.715 19.105 46 15 46c-7.117 0-11 1.982-11 3v6a1 1 0 0 1-1 1ZM32 24a1 1 0 0 1-.707-1.707L46.364 7.222a1 1 0 0 1 1.414 1.414L32.707 23.707A1 1 0 0 1 32 24Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M46 15a1.01 1.01 0 0 1-.243-.03l-4-1a1 1 0 0 1-.464-1.677l5-5a1 1 0 0 1 .95-.263l4 1a1 1 0 0 1 .464 1.677l-5 5A1 1 0 0 1 46 15Zm-2.044-2.542 1.737.435 3.351-3.351-1.737-.435Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M42 14a1.016 1.016 0 0 1-.267-.036 1 1 0 0 1-.7-.721l-1-4a1 1 0 0 1 .263-.95l5-5a1 1 0 0 1 1.677.464l1 4a1 1 0 0 1-.263.95l-5 5A1 1 0 0 1 42 14Zm.107-4.693.435 1.737 3.351-3.351-.435-1.737ZM15.115 26a1 1 0 0 1-.992-.884A18.429 18.429 0 0 1 14 23 18.009 18.009 0 0 1 39.412 6.592a1 1 0 0 1-.824 1.823A16.008 16.008 0 0 0 16 23a16.423 16.423 0 0 0 .109 1.884 1 1 0 0 1-.877 1.109.918.918 0 0 1-.117.007ZM48.885 26a.918.918 0 0 1-.117-.007 1 1 0 0 1-.877-1.109A16.423 16.423 0 0 0 48 23a15.87 15.87 0 0 0-1.415-6.588 1 1 0 0 1 1.823-.824A17.867 17.867 0 0 1 50 23a18.429 18.429 0 0 1-.123 2.116 1 1 0 0 1-.992.884ZM32 29a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M38.319 33a1 1 0 0 1-.577-1.818 10 10 0 1 0-11.484 0 1 1 0 1 1-1.152 1.636 12 12 0 1 1 13.788 0 1 1 0 0 1-.575.182Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Cross-Device Access</h2>
                            <p>
                              Accessible from web, tablet, or mobile apps –
                              wherever you are.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>What We’ve Delivered</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Operations dashboards for
                          real-time production tracking
                        </li>
                        <li>
                          <strong>2. </strong> Live sales and inventory
                          dashboards with drill-down by location
                        </li>
                        <li>
                          <strong>3. </strong> Automated reports reducing manual
                          reporting time by 80%
                        </li>
                        <li>
                          <strong>4. </strong> Performance dashboards with
                          AI-generated predictions
                        </li>
                      </ul>
                      <p>
                        <strong>Compatible With</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Manufacturing & Process Operations</span>
                        <span>Sales & Inventory Teams</span>
                        <span>HR & KPI Monitoring</span>
                        <span>Financial Reporting</span>
                        <span>IoT & Sensor-Based Systems</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Our Process</h2>
                      <ul>
                        <li>
                          <strong>1. Requirement Mapping : </strong> Understand
                          what needs to be monitored, by whom, and how often
                        </li>
                        <li>
                          <strong>2. Data Connection & Structuring : </strong>
                          Link to your data sources (sheets, databases, APIs)
                        </li>
                        <li>
                          <strong>3. Dashboard Design : </strong> Build
                          intuitive, role-based dashboards and reports
                        </li>
                        <li>
                          <strong>4. Automation Setup : </strong> Configure
                          triggers, alerts, and delivery schedules
                        </li>
                        <li>
                          <strong>5. Launch & Training : </strong> Go live with
                          full documentation and onboarding
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="CommonBtmWrap">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-9">
                    <div className="dataWrap">
                      <h2>Empower Your Teams with Live Insights</h2>
                      <p>
                        You can’t improve what you don’t measure. Let your team
                        take action backed by real-time data.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "AIPoweredForecasting" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>AI-Powered Forecasting</h2>
                      <p>Predict Trends. Optimize Operations. Stay Ahead.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap commonCotentWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <h2>Overview</h2>
                      <p>
                        Take the guesswork out of decision-making. Our
                        <strong>AI-Powered Forecasting</strong> services use
                        machine learning and statistical models to turn your
                        historical data into future insights. From sales and
                        inventory to performance and demand — we help you
                        forecast outcomes with confidence and precision.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Data-Driven Prediction Models</h2>
                              <ul>
                                <li>Time-series forecasting</li>
                                <li>Regression-based outcome models</li>
                                <li>
                                  Classification models for pattern detection
                                </li>
                                <li>
                                  Real-time adaptive models that learn as new
                                  data comes in
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Use Cases We Serve</h2>
                              <ul>
                                <li>Sales & Demand Forecasting</li>
                                <li>Inventory & Supply Planning</li>
                                <li>Production Throughput Forecasting</li>
                                <li>Resource & Capacity Planning</li>
                                <li>Maintenance Prediction & Alerts</li>
                                <li>Customer Behavior & Retention Forecasts</li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>System Integration</h2>
                              <ul>
                                <li>
                                  Seamless integration with your ERP, CRM,
                                  Excel/Sheets, or custom platforms
                                </li>
                                <li>
                                  Forecasts accessible via dashboard or
                                  automated report delivery
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Smart Visualizations</h2>
                              <ul>
                                <li>
                                  Interactive graphs and predictive trend lines
                                </li>
                                <li>
                                  Confidence intervals and anomaly detection
                                </li>
                                <li>What-if scenario simulations</li>
                              </ul>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Benefits to Your Business</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M472 16H312a24.028 24.028 0 0 0-24 24v96a24.028 24.028 0 0 0 24 24h36.687l13.656 13.657a8 8 0 0 0 11.314 0L387.313 160H472a24.028 24.028 0 0 0 24-24V40a24.028 24.028 0 0 0-24-24zm8 120a8.009 8.009 0 0 1-8 8h-88a8 8 0 0 0-5.657 2.343L368 156.687l-10.343-10.344A8 8 0 0 0 352 144h-40a8.009 8.009 0 0 1-8-8V40a8.009 8.009 0 0 1 8-8h160a8.009 8.009 0 0 1 8 8z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M376 56h-32v16h12.686l-34.343 34.343 11.314 11.314L368 83.314V96h16V64a8 8 0 0 0-8-8zM400 48h64v16h-64zM400 80h64v16h-64zM400 112h64v16h-64zM424 408a40.045 40.045 0 0 0 40-40V184h-16v144H64V128a24.028 24.028 0 0 1 24-24h184V88H88a40.045 40.045 0 0 0-40 40v240a40.045 40.045 0 0 0 40 40h99.867l-17.143 40H136a24 24 0 0 0 0 48h240a24 24 0 0 0 0-48h-34.724l-17.143-40zM64 368v-24h384v24a24.028 24.028 0 0 1-24 24H88a24.028 24.028 0 0 1-24-24zm320 104a8.009 8.009 0 0 1-8 8H136a8 8 0 0 1 0-16h240a8.009 8.009 0 0 1 8 8zm-60.133-24H188.133l17.143-40h101.448z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M248 360h16v16h-16zM88 144v152a8 8 0 0 0 8 8h160v-16h-24v-96h-16v96h-16v-64h-16v64h-16v-80h-16v80h-16v-48h-16v48h-16V144zM416 192H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h120a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-112 16h64v16h-64zm104 16h-24v-16h24zM416 304a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm-8-16h-72v-16h72zm-104-16h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M120 208h16v16h-16zM152 176h16v16h-16zM184 192h16v16h-16zM216 160h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Reduce Operational Surprises</h2>
                            <p>
                              Know what’s coming – from sales dips to production
                              peaks.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M19.869 207v135c0 5.523 4.477 10 10 10H49.8c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.779c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.78c2.968-27.649 26.369-49.182 54.807-49.182s51.839 21.533 54.807 49.182h19.931c5.523 0 10-4.477 10-10V52.069H19.869V172M390 19.46H17.5c-5.523 0-10 4.477-10 10v12.609c0 5.523 4.477 10 10 10h477c5.523 0 10-4.477 10-10V29.46c0-5.523-4.477-10-10-10H425M408 492.54h69.131c8.284 0 15-6.716 15-15v-26.82a29.978 29.978 0 0 0-17.588-27.297l-39.362-17.864c-8.161 4.774-17.651 7.522-27.788 7.522s-19.627-2.748-27.788-7.522l-39.362 17.864a29.906 29.906 0 0 0-8.547 5.857 29.963 29.963 0 0 1 9.041 21.44v41.82H373M171.756 423.423l-39.362-17.864a54.854 54.854 0 0 1-27.788 7.522 54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v26.82c0 8.284 6.716 15 15 15h136.393v-41.82a29.963 29.963 0 0 1 9.041-21.44 29.888 29.888 0 0 0-8.546-5.857z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="m323.15 423.423-39.362-17.864A54.854 54.854 0 0 1 256 413.081a54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v41.82h169.476v-41.82a29.976 29.976 0 0 0-17.588-27.297z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <circle
                                  cx="407.394"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 407.387 357.94)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="104.607"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 104.606 357.942)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="256"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 255.996 357.941)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <path
                                  d="M189.729 148.02a5 5 0 0 1-5-5v-26.866c-12.185-7.235-26.405-11.402-41.604-11.402-45.08 0-81.625 36.545-81.625 81.625s36.545 81.625 81.625 81.625 81.625-36.545 81.625-81.625c0-13.867-3.469-26.919-9.569-38.356h-25.452z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M224.749 186.375h-81.624v-81.624M292.172 148.02H189.729a5 5 0 0 1-5-5V98.047a5 5 0 0 1 5-5h102.443a5 5 0 0 1 5 5v44.972a5 5 0 0 1-5 5.001zM214.714 120.533h52.473M256.213 187.5h11.619M256.213 222.477h11.619M256.213 257.455h11.619M297.408 187.5H450.5M297.408 222.477H395.5M297.408 257.455H450.5M450.5 135.533h-61.364M389.136 105.533H450.5M417.5 222.477h33"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Better Planning & Budgeting</h2>
                            <p>
                              Use historical patterns and AI models to plan more
                              accurately.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 66 66"
                            >
                              <g>
                                <path
                                  d="M45.93 6.96h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 6.82c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 10.89h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 10.75c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 14.82h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 14.69c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM27.71 49.82h-3.98c-.48 0-.88.39-.88.88v8.39h-2.21V46.26c0-.48-.39-.88-.88-.88h-3.98c-.48 0-.88.39-.88.88v12.82h-2.21V40.86c0-.48-.39-.88-.88-.88H7.86c-.48 0-.88.39-.88.88v18.23h-.44c-.48 0-.88.39-.88.88s.39.88.88.88h23.02c.48 0 .88-.39.88-.88s-.39-.88-.88-.88h-.97V50.7c0-.49-.39-.88-.88-.88zm-3.1 1.75h2.23v7.52h-2.23zm-7.94-4.43h2.23v11.95h-2.23zm-7.94-5.41h2.23v17.35H8.73zM47.43 45.12c4.37-4.37 4.37-11.49 0-15.86-2.12-2.12-4.93-3.28-7.93-3.28s-5.81 1.17-7.93 3.29-3.28 4.93-3.28 7.93c0 2.99 1.17 5.81 3.29 7.93s4.94 3.28 7.93 3.28 5.8-1.18 7.92-3.29zm-17.4-7.93c0-2.53.98-4.9 2.77-6.69s4.17-2.77 6.69-2.77c2.53 0 4.9.98 6.69 2.77 3.69 3.69 3.69 9.7 0 13.39a9.403 9.403 0 0 1-6.69 2.77c-2.53 0-4.91-.98-6.69-2.77a9.443 9.443 0 0 1-2.77-6.7z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="m63.23 55.37-7.93-7.93a2.807 2.807 0 0 0-.41-3.44l-1.21-1.21c.7-1.76 1.07-3.66 1.07-5.61 0-4.08-1.59-7.91-4.47-10.79-5.95-5.95-15.63-5.95-21.58 0a15.158 15.158 0 0 0-4.47 10.79c0 4.07 1.59 7.91 4.47 10.79 2.97 2.97 6.88 4.46 10.79 4.46 1.9 0 3.81-.36 5.6-1.07l1.22 1.22a2.799 2.799 0 0 0 3.44.41l7.93 7.93c.74.74 1.73 1.15 2.77 1.15s2.03-.41 2.77-1.15 1.15-1.73 1.15-2.77-.4-2.03-1.14-2.78zm-33.28-8.63c-2.55-2.55-3.96-5.94-3.96-9.55s1.4-7 3.96-9.55c2.55-2.55 5.94-3.96 9.55-3.96s7 1.41 9.55 3.96S53 33.58 53 37.19c0 1.91-.4 3.75-1.15 5.44-.01.02-.02.03-.02.05-.66 1.49-1.59 2.87-2.78 4.05A13.37 13.37 0 0 1 45 49.51c-.02.01-.04.02-.05.03-1.69.75-3.54 1.15-5.44 1.15-3.62 0-7.01-1.4-9.56-3.95zm17.6 4.61-.77-.77a14.78 14.78 0 0 0 3.5-2.61c1.05-1.05 1.92-2.23 2.61-3.49l.76.76a1.06 1.06 0 0 1 0 1.5l-.15.15-4.3 4.31-.14.14c-.4.41-1.1.41-1.51.01zm14.44 8.33c-.82.82-2.25.82-3.07 0l-7.86-7.86 3.07-3.07 7.86 7.86c.41.41.64.96.64 1.54s-.23 1.12-.64 1.53z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M40.37 44.09v-.67c1.57-.39 2.74-1.81 2.74-3.49 0-1.99-1.62-3.61-3.61-3.61-1.03 0-1.86-.84-1.86-1.86s.84-1.86 1.86-1.86 1.86.84 1.86 1.86c0 .48.39.88.88.88s.88-.39.88-.88c0-1.69-1.17-3.1-2.74-3.49v-.67c0-.48-.39-.88-.88-.88s-.88.39-.88.88v.67c-1.57.39-2.74 1.81-2.74 3.49 0 1.99 1.62 3.61 3.61 3.61 1.03 0 1.86.84 1.86 1.86 0 1.03-.84 1.86-1.86 1.86s-1.86-.84-1.86-1.86c0-.48-.39-.88-.88-.88s-.88.39-.88.88c0 1.69 1.17 3.1 2.74 3.49v.67c0 .48.39.88.88.88s.88-.4.88-.88zM25.74 17.29h-8.22V9.08c0-.48-.39-.88-.88-.88-5.5 0-9.97 4.47-9.97 9.97s4.47 9.97 9.97 9.97 9.97-4.47 9.97-9.97a.88.88 0 0 0-.87-.88zm-9.1 9.1c-4.53 0-8.22-3.69-8.22-8.22 0-4.24 3.22-7.73 7.34-8.17v8.17c0 .48.39.88.88.88h8.17c-.43 4.12-3.93 7.34-8.17 7.34z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M29.64 15.14c0-5.5-4.47-9.97-9.97-9.97-.48 0-.88.39-.88.88v9.09c0 .48.39.88.88.88h9.09c.49-.01.88-.4.88-.88zm-9.09-.88v-7.3c3.83.41 6.89 3.46 7.3 7.3z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M50.37 55.29c-.48 0-.88.39-.88.88v3.8c0 1.75-1.42 3.17-3.17 3.17H6.54c-1.75 0-3.17-1.42-3.17-3.17V6.04c0-1.75 1.42-3.17 3.17-3.17h39.79c1.75 0 3.17 1.42 3.17 3.17v16.32c0 .48.39.88.88.88s.88-.39.88-.88V6.04a4.93 4.93 0 0 0-4.92-4.92H6.54a4.93 4.93 0 0 0-4.92 4.92v53.92a4.93 4.93 0 0 0 4.92 4.92h39.79a4.93 4.93 0 0 0 4.92-4.92v-3.8a.886.886 0 0 0-.88-.87z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Inventory Optimization</h2>
                            <p>
                              Avoid overstocking and understocking with accurate
                              demand forecasts.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M421.713 263.57V244.5c0-33.137-26.863-60-60-60h-40c-33.137 0-60 26.863-60 60v19.07"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M301.713 263.57V244.5c0-11.046 8.954-20 20-20h40c11.046 0 20 8.954 20 20v19.07M181.713 314.077v151.791c0 21.336 17.296 38.632 38.632 38.632h242.736c21.336 0 38.632-17.296 38.632-38.632V314.077M388.506 386.834h-93.577"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M242.963 386.687c-34.208-2.275-61.25-30.743-61.25-65.527v-18.028c0-21.336 17.296-38.632 38.632-38.632h242.736c21.336 0 38.632 17.296 38.632 38.632v18.028c0 34.632-26.807 63.004-60.803 65.496"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M243.777 502.5v-133c0-13.807 11.193-25 25-25h0c13.807 0 25 11.193 25 25v133M389.649 455.884V502.5M439.649 502.5v-133c0-13.807-11.193-25-25-25h0c-13.807 0-25 11.193-25 25v51.235M279.269 296.729v11.999M404.158 296.729v11.999M325.25 308.371c4.003 4.593 9.892 7.5 16.463 7.5 6.571 0 12.46-2.907 16.463-7.5M83.23 55.695C118.902 25.622 164.978 7.5 215.287 7.5c113.218 0 205 91.782 205 205 0 4.286-.132 8.541-.391 12.762M180.319 414.529C83.758 397.934 10.287 313.797 10.287 212.5c0-50.433 18.211-96.612 48.417-132.32"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="m386.431 188.935-8.489-16.021a64.72 64.72 0 0 0-95.608-21.779l-18.121 13.368c-9.564 7.055-22.875 6.81-31.805-1.032-9.789-8.597-11.347-23.217-3.661-33.672l12.28-16.705a71.313 71.313 0 0 0 5.713-75.326h0a71.045 71.045 0 0 0-10.452-14.904A71.507 71.507 0 0 0 217.933 8.4M38.64 312.726c13.061 1.073 25.711-5.783 31.821-17.706l28.285-55.196a29.473 29.473 0 0 1 11.113-11.864v0a29.487 29.487 0 0 1 15.754-4.176h0c15.005.313 27.371 11.839 28.758 26.758.959 10.313 6.747 19.658 15.997 24.317 6.184 3.115 12.187 4.25 17.854 4.046M289.764 23.49l13.071 34.297c19.719 51.74 69.852 48.839 85.562 48.844M180.684 351.222a54.999 54.999 0 0 1-14.702 2.805 55.028 55.028 0 0 1-27.54-5.716c-21.271-10.635-46.473-5.08-61.471 12.13"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Informed Decision-Making</h2>
                            <p>
                              Make proactive moves backed by data, not
                              assumptions.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M32 48a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM44 61a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3s-11 1.982-11 3v6a1 1 0 0 1-2 0v-6c0-3.283 6.54-5 13-5s13 1.717 13 5v6a1 1 0 0 1-1 1ZM49 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M61 56a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3-4.1 0-7.9.715-9.9 1.866a1 1 0 1 1-1-1.732C40.425 44.8 44.5 44 49 44c6.46 0 13 1.717 13 5v6a1 1 0 0 1-1 1ZM15 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM3 56a1 1 0 0 1-1-1v-6c0-3.283 6.54-5 13-5 4.5 0 8.575.8 10.894 2.134a1 1 0 1 1-1 1.732C22.9 46.715 19.105 46 15 46c-7.117 0-11 1.982-11 3v6a1 1 0 0 1-1 1ZM32 24a1 1 0 0 1-.707-1.707L46.364 7.222a1 1 0 0 1 1.414 1.414L32.707 23.707A1 1 0 0 1 32 24Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M46 15a1.01 1.01 0 0 1-.243-.03l-4-1a1 1 0 0 1-.464-1.677l5-5a1 1 0 0 1 .95-.263l4 1a1 1 0 0 1 .464 1.677l-5 5A1 1 0 0 1 46 15Zm-2.044-2.542 1.737.435 3.351-3.351-1.737-.435Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M42 14a1.016 1.016 0 0 1-.267-.036 1 1 0 0 1-.7-.721l-1-4a1 1 0 0 1 .263-.95l5-5a1 1 0 0 1 1.677.464l1 4a1 1 0 0 1-.263.95l-5 5A1 1 0 0 1 42 14Zm.107-4.693.435 1.737 3.351-3.351-.435-1.737ZM15.115 26a1 1 0 0 1-.992-.884A18.429 18.429 0 0 1 14 23 18.009 18.009 0 0 1 39.412 6.592a1 1 0 0 1-.824 1.823A16.008 16.008 0 0 0 16 23a16.423 16.423 0 0 0 .109 1.884 1 1 0 0 1-.877 1.109.918.918 0 0 1-.117.007ZM48.885 26a.918.918 0 0 1-.117-.007 1 1 0 0 1-.877-1.109A16.423 16.423 0 0 0 48 23a15.87 15.87 0 0 0-1.415-6.588 1 1 0 0 1 1.823-.824A17.867 17.867 0 0 1 50 23a18.429 18.429 0 0 1-.123 2.116 1 1 0 0 1-.992.884ZM32 29a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M38.319 33a1 1 0 0 1-.577-1.818 10 10 0 1 0-11.484 0 1 1 0 1 1-1.152 1.636 12 12 0 1 1 13.788 0 1 1 0 0 1-.575.182Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Custom-Tuned Models</h2>
                            <p>
                              Our AI adapts to your unique patterns — no generic
                              templates.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Real Results We've Delivered</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Forecasted manufacturing output
                          using 1 year of historical production data
                        </li>
                        <li>
                          <strong>2. </strong> Predicted order volumes to
                          improve stock planning by 35%
                        </li>
                        <li>
                          <strong>3. </strong> Built AI alerts for workload
                          spikes, reducing scheduling conflicts
                        </li>
                        <li>
                          <strong>4. </strong> Identified early signs of delays
                          and process bottlenecks
                        </li>
                      </ul>
                      <p>
                        <strong>Industries We Serve</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Manufacturing & Production</span>
                        <span>Logistics & Supply Chain</span>
                        <span>Healthcare & Pharmacy</span>
                        <span>Retail & E-Commerce</span>
                        <span>Education & Operations Management</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Our Approach</h2>
                      <ul>
                        <li>
                          <strong>1. Data Collection & Cleaning : </strong> We
                          gather historical data and prepare it for modeling.
                        </li>
                        <li>
                          <strong>2. Model Selection & Training : </strong>
                          Choose the best-fit AI models (ARIMA, LSTM, Random
                          Forest, etc.) based on your use case.
                        </li>
                        <li>
                          <strong>3. Validation & Tuning : </strong> Test
                          predictions against real data, fine-tune for accuracy.
                        </li>
                        <li>
                          <strong>4. Integration & Automation : </strong>
                          Connect the model to your dashboard or internal system
                          for live updates.
                        </li>
                        <li>
                          <strong>5. Continuous Learning : </strong> Models
                          improve as more data becomes available — no manual
                          intervention needed.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="CommonBtmWrap">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-9">
                    <div className="dataWrap">
                      <h2>Forecast Smarter with AI</h2>
                      <p>
                        The future isn’t uncertain — it’s underutilized.
                        Leverage your data to predict, plan, and perform better.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "CloudAccessibility" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Cloud Accessibility</h2>
                      <p>
                        Grow Without Limits. Access Anywhere. Scale with
                        Confidence.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap commonCotentWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <h2>Overview</h2>
                      <p>
                        As your business evolves, your systems must keep pace.
                        Our <strong>Cloud-Based Scalability</strong> services
                        ensure your applications, data, and workflows grow
                        seamlessly — without the need for expensive
                        infrastructure or performance bottlenecks. We help you
                        unlock the
                        <strong>power, flexibility, and reliability</strong> of
                        the cloud to support your future.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Cloud Architecture Design</h2>
                              <ul>
                                <li>
                                  Design scalable, secure cloud environments
                                </li>
                                <li>
                                  Microservices and container-based
                                  infrastructure
                                </li>
                                <li>Multi-region and failover-ready systems</li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Application & Data Migration</h2>
                              <ul>
                                <li>
                                  Move legacy systems to cloud platforms (AWS,
                                  Azure, GCP)
                                </li>
                                <li>
                                  Migrate files, databases, and applications
                                  with zero data loss
                                </li>
                                <li>
                                  Set up hybrid and multi-cloud environments if
                                  needed
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Auto-Scaling & Load Balancing</h2>
                              <ul>
                                <li>
                                  Automatically handle traffic spikes or user
                                  growth
                                </li>
                                <li>
                                  Pay only for what you use — elastic
                                  infrastructure
                                </li>
                                <li>No manual provisioning or delays</li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Security & Compliance</h2>
                              <ul>
                                <li>Encryption at rest and in transit</li>
                                <li>Role-based access controls</li>
                                <li>
                                  Regular audits and compliance-ready setups
                                  (HIPAA, ISO, etc.)
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WebsiteDevelopmentIco5}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Monitoring & Optimization</h2>
                              <ul>
                                <li>Real-time usage dashboards</li>
                                <li>Cost optimization tools</li>
                                <li>
                                  Alerting and logging systems for stability and
                                  performance
                                </li>
                              </ul>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Benefits to Your Business</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M472 16H312a24.028 24.028 0 0 0-24 24v96a24.028 24.028 0 0 0 24 24h36.687l13.656 13.657a8 8 0 0 0 11.314 0L387.313 160H472a24.028 24.028 0 0 0 24-24V40a24.028 24.028 0 0 0-24-24zm8 120a8.009 8.009 0 0 1-8 8h-88a8 8 0 0 0-5.657 2.343L368 156.687l-10.343-10.344A8 8 0 0 0 352 144h-40a8.009 8.009 0 0 1-8-8V40a8.009 8.009 0 0 1 8-8h160a8.009 8.009 0 0 1 8 8z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M376 56h-32v16h12.686l-34.343 34.343 11.314 11.314L368 83.314V96h16V64a8 8 0 0 0-8-8zM400 48h64v16h-64zM400 80h64v16h-64zM400 112h64v16h-64zM424 408a40.045 40.045 0 0 0 40-40V184h-16v144H64V128a24.028 24.028 0 0 1 24-24h184V88H88a40.045 40.045 0 0 0-40 40v240a40.045 40.045 0 0 0 40 40h99.867l-17.143 40H136a24 24 0 0 0 0 48h240a24 24 0 0 0 0-48h-34.724l-17.143-40zM64 368v-24h384v24a24.028 24.028 0 0 1-24 24H88a24.028 24.028 0 0 1-24-24zm320 104a8.009 8.009 0 0 1-8 8H136a8 8 0 0 1 0-16h240a8.009 8.009 0 0 1 8 8zm-60.133-24H188.133l17.143-40h101.448z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M248 360h16v16h-16zM88 144v152a8 8 0 0 0 8 8h160v-16h-24v-96h-16v96h-16v-64h-16v64h-16v-80h-16v80h-16v-48h-16v48h-16V144zM416 192H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h120a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-112 16h64v16h-64zm104 16h-24v-16h24zM416 304a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H296a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm-8-16h-72v-16h72zm-104-16h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M120 208h16v16h-16zM152 176h16v16h-16zM184 192h16v16h-16zM216 160h16v16h-16z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>On-Demand Growth</h2>
                            <p>
                              Easily add users, locations, or workloads as your
                              business expands.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M19.869 207v135c0 5.523 4.477 10 10 10H49.8c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.779c2.968-27.649 26.37-49.182 54.807-49.182 28.438 0 51.839 21.533 54.807 49.182h41.78c2.968-27.649 26.369-49.182 54.807-49.182s51.839 21.533 54.807 49.182h19.931c5.523 0 10-4.477 10-10V52.069H19.869V172M390 19.46H17.5c-5.523 0-10 4.477-10 10v12.609c0 5.523 4.477 10 10 10h477c5.523 0 10-4.477 10-10V29.46c0-5.523-4.477-10-10-10H425M408 492.54h69.131c8.284 0 15-6.716 15-15v-26.82a29.978 29.978 0 0 0-17.588-27.297l-39.362-17.864c-8.161 4.774-17.651 7.522-27.788 7.522s-19.627-2.748-27.788-7.522l-39.362 17.864a29.906 29.906 0 0 0-8.547 5.857 29.963 29.963 0 0 1 9.041 21.44v41.82H373M171.756 423.423l-39.362-17.864a54.854 54.854 0 0 1-27.788 7.522 54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v26.82c0 8.284 6.716 15 15 15h136.393v-41.82a29.963 29.963 0 0 1 9.041-21.44 29.888 29.888 0 0 0-8.546-5.857z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="m323.15 423.423-39.362-17.864A54.854 54.854 0 0 1 256 413.081a54.854 54.854 0 0 1-27.788-7.522l-39.362 17.864a29.976 29.976 0 0 0-17.588 27.297v41.82h169.476v-41.82a29.976 29.976 0 0 0-17.588-27.297z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                ></path>
                                <circle
                                  cx="407.394"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 407.387 357.94)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="104.607"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 104.606 357.942)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <circle
                                  cx="256"
                                  cy="357.949"
                                  r="55.131"
                                  transform="rotate(-67.5 255.996 357.941)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></circle>
                                <path
                                  d="M189.729 148.02a5 5 0 0 1-5-5v-26.866c-12.185-7.235-26.405-11.402-41.604-11.402-45.08 0-81.625 36.545-81.625 81.625s36.545 81.625 81.625 81.625 81.625-36.545 81.625-81.625c0-13.867-3.469-26.919-9.569-38.356h-25.452z"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M224.749 186.375h-81.624v-81.624M292.172 148.02H189.729a5 5 0 0 1-5-5V98.047a5 5 0 0 1 5-5h102.443a5 5 0 0 1 5 5v44.972a5 5 0 0 1-5 5.001zM214.714 120.533h52.473M256.213 187.5h11.619M256.213 222.477h11.619M256.213 257.455h11.619M297.408 187.5H450.5M297.408 222.477H395.5M297.408 257.455H450.5M450.5 135.533h-61.364M389.136 105.533H450.5M417.5 222.477h33"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ccdee"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Global Accessibility</h2>
                            <p>
                              Access your tools and data from anywhere, securely
                              and reliably.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 66 66"
                            >
                              <g>
                                <path
                                  d="M45.93 6.96h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 6.82c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 10.89h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 10.75c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM45.93 14.82h-8.5c-.48 0-.88.39-.88.88s.39.88.88.88h8.5c.48 0 .88-.39.88-.88s-.4-.88-.88-.88zM34.07 14.69c-.56 0-1.01.45-1.01 1.01s.45 1.01 1.01 1.01 1.01-.45 1.01-1.01-.45-1.01-1.01-1.01zM27.71 49.82h-3.98c-.48 0-.88.39-.88.88v8.39h-2.21V46.26c0-.48-.39-.88-.88-.88h-3.98c-.48 0-.88.39-.88.88v12.82h-2.21V40.86c0-.48-.39-.88-.88-.88H7.86c-.48 0-.88.39-.88.88v18.23h-.44c-.48 0-.88.39-.88.88s.39.88.88.88h23.02c.48 0 .88-.39.88-.88s-.39-.88-.88-.88h-.97V50.7c0-.49-.39-.88-.88-.88zm-3.1 1.75h2.23v7.52h-2.23zm-7.94-4.43h2.23v11.95h-2.23zm-7.94-5.41h2.23v17.35H8.73zM47.43 45.12c4.37-4.37 4.37-11.49 0-15.86-2.12-2.12-4.93-3.28-7.93-3.28s-5.81 1.17-7.93 3.29-3.28 4.93-3.28 7.93c0 2.99 1.17 5.81 3.29 7.93s4.94 3.28 7.93 3.28 5.8-1.18 7.92-3.29zm-17.4-7.93c0-2.53.98-4.9 2.77-6.69s4.17-2.77 6.69-2.77c2.53 0 4.9.98 6.69 2.77 3.69 3.69 3.69 9.7 0 13.39a9.403 9.403 0 0 1-6.69 2.77c-2.53 0-4.91-.98-6.69-2.77a9.443 9.443 0 0 1-2.77-6.7z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="m63.23 55.37-7.93-7.93a2.807 2.807 0 0 0-.41-3.44l-1.21-1.21c.7-1.76 1.07-3.66 1.07-5.61 0-4.08-1.59-7.91-4.47-10.79-5.95-5.95-15.63-5.95-21.58 0a15.158 15.158 0 0 0-4.47 10.79c0 4.07 1.59 7.91 4.47 10.79 2.97 2.97 6.88 4.46 10.79 4.46 1.9 0 3.81-.36 5.6-1.07l1.22 1.22a2.799 2.799 0 0 0 3.44.41l7.93 7.93c.74.74 1.73 1.15 2.77 1.15s2.03-.41 2.77-1.15 1.15-1.73 1.15-2.77-.4-2.03-1.14-2.78zm-33.28-8.63c-2.55-2.55-3.96-5.94-3.96-9.55s1.4-7 3.96-9.55c2.55-2.55 5.94-3.96 9.55-3.96s7 1.41 9.55 3.96S53 33.58 53 37.19c0 1.91-.4 3.75-1.15 5.44-.01.02-.02.03-.02.05-.66 1.49-1.59 2.87-2.78 4.05A13.37 13.37 0 0 1 45 49.51c-.02.01-.04.02-.05.03-1.69.75-3.54 1.15-5.44 1.15-3.62 0-7.01-1.4-9.56-3.95zm17.6 4.61-.77-.77a14.78 14.78 0 0 0 3.5-2.61c1.05-1.05 1.92-2.23 2.61-3.49l.76.76a1.06 1.06 0 0 1 0 1.5l-.15.15-4.3 4.31-.14.14c-.4.41-1.1.41-1.51.01zm14.44 8.33c-.82.82-2.25.82-3.07 0l-7.86-7.86 3.07-3.07 7.86 7.86c.41.41.64.96.64 1.54s-.23 1.12-.64 1.53z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M40.37 44.09v-.67c1.57-.39 2.74-1.81 2.74-3.49 0-1.99-1.62-3.61-3.61-3.61-1.03 0-1.86-.84-1.86-1.86s.84-1.86 1.86-1.86 1.86.84 1.86 1.86c0 .48.39.88.88.88s.88-.39.88-.88c0-1.69-1.17-3.1-2.74-3.49v-.67c0-.48-.39-.88-.88-.88s-.88.39-.88.88v.67c-1.57.39-2.74 1.81-2.74 3.49 0 1.99 1.62 3.61 3.61 3.61 1.03 0 1.86.84 1.86 1.86 0 1.03-.84 1.86-1.86 1.86s-1.86-.84-1.86-1.86c0-.48-.39-.88-.88-.88s-.88.39-.88.88c0 1.69 1.17 3.1 2.74 3.49v.67c0 .48.39.88.88.88s.88-.4.88-.88zM25.74 17.29h-8.22V9.08c0-.48-.39-.88-.88-.88-5.5 0-9.97 4.47-9.97 9.97s4.47 9.97 9.97 9.97 9.97-4.47 9.97-9.97a.88.88 0 0 0-.87-.88zm-9.1 9.1c-4.53 0-8.22-3.69-8.22-8.22 0-4.24 3.22-7.73 7.34-8.17v8.17c0 .48.39.88.88.88h8.17c-.43 4.12-3.93 7.34-8.17 7.34z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M29.64 15.14c0-5.5-4.47-9.97-9.97-9.97-.48 0-.88.39-.88.88v9.09c0 .48.39.88.88.88h9.09c.49-.01.88-.4.88-.88zm-9.09-.88v-7.3c3.83.41 6.89 3.46 7.3 7.3z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M50.37 55.29c-.48 0-.88.39-.88.88v3.8c0 1.75-1.42 3.17-3.17 3.17H6.54c-1.75 0-3.17-1.42-3.17-3.17V6.04c0-1.75 1.42-3.17 3.17-3.17h39.79c1.75 0 3.17 1.42 3.17 3.17v16.32c0 .48.39.88.88.88s.88-.39.88-.88V6.04a4.93 4.93 0 0 0-4.92-4.92H6.54a4.93 4.93 0 0 0-4.92 4.92v53.92a4.93 4.93 0 0 0 4.92 4.92h39.79a4.93 4.93 0 0 0 4.92-4.92v-3.8a.886.886 0 0 0-.88-.87z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>No Downtime</h2>
                            <p>
                              Auto-scaling and failover capabilities ensure
                              uninterrupted service.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M421.713 263.57V244.5c0-33.137-26.863-60-60-60h-40c-33.137 0-60 26.863-60 60v19.07"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M301.713 263.57V244.5c0-11.046 8.954-20 20-20h40c11.046 0 20 8.954 20 20v19.07M181.713 314.077v151.791c0 21.336 17.296 38.632 38.632 38.632h242.736c21.336 0 38.632-17.296 38.632-38.632V314.077M388.506 386.834h-93.577"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M242.963 386.687c-34.208-2.275-61.25-30.743-61.25-65.527v-18.028c0-21.336 17.296-38.632 38.632-38.632h242.736c21.336 0 38.632 17.296 38.632 38.632v18.028c0 34.632-26.807 63.004-60.803 65.496"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M243.777 502.5v-133c0-13.807 11.193-25 25-25h0c13.807 0 25 11.193 25 25v133M389.649 455.884V502.5M439.649 502.5v-133c0-13.807-11.193-25-25-25h0c-13.807 0-25 11.193-25 25v51.235M279.269 296.729v11.999M404.158 296.729v11.999M325.25 308.371c4.003 4.593 9.892 7.5 16.463 7.5 6.571 0 12.46-2.907 16.463-7.5M83.23 55.695C118.902 25.622 164.978 7.5 215.287 7.5c113.218 0 205 91.782 205 205 0 4.286-.132 8.541-.391 12.762M180.319 414.529C83.758 397.934 10.287 313.797 10.287 212.5c0-50.433 18.211-96.612 48.417-132.32"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="m386.431 188.935-8.489-16.021a64.72 64.72 0 0 0-95.608-21.779l-18.121 13.368c-9.564 7.055-22.875 6.81-31.805-1.032-9.789-8.597-11.347-23.217-3.661-33.672l12.28-16.705a71.313 71.313 0 0 0 5.713-75.326h0a71.045 71.045 0 0 0-10.452-14.904A71.507 71.507 0 0 0 217.933 8.4M38.64 312.726c13.061 1.073 25.711-5.783 31.821-17.706l28.285-55.196a29.473 29.473 0 0 1 11.113-11.864v0a29.487 29.487 0 0 1 15.754-4.176h0c15.005.313 27.371 11.839 28.758 26.758.959 10.313 6.747 19.658 15.997 24.317 6.184 3.115 12.187 4.25 17.854 4.046M289.764 23.49l13.071 34.297c19.719 51.74 69.852 48.839 85.562 48.844M180.684 351.222a54.999 54.999 0 0 1-14.702 2.805 55.028 55.028 0 0 1-27.54-5.716c-21.271-10.635-46.473-5.08-61.471 12.13"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Lower IT Costs</h2>
                            <p>
                              Reduce infrastructure costs by only paying for
                              what you use.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M32 48a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM44 61a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3s-11 1.982-11 3v6a1 1 0 0 1-2 0v-6c0-3.283 6.54-5 13-5s13 1.717 13 5v6a1 1 0 0 1-1 1ZM49 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M61 56a1 1 0 0 1-1-1v-6c0-1.018-3.883-3-11-3-4.1 0-7.9.715-9.9 1.866a1 1 0 1 1-1-1.732C40.425 44.8 44.5 44 49 44c6.46 0 13 1.717 13 5v6a1 1 0 0 1-1 1ZM15 43a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM3 56a1 1 0 0 1-1-1v-6c0-3.283 6.54-5 13-5 4.5 0 8.575.8 10.894 2.134a1 1 0 1 1-1 1.732C22.9 46.715 19.105 46 15 46c-7.117 0-11 1.982-11 3v6a1 1 0 0 1-1 1ZM32 24a1 1 0 0 1-.707-1.707L46.364 7.222a1 1 0 0 1 1.414 1.414L32.707 23.707A1 1 0 0 1 32 24Z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M46 15a1.01 1.01 0 0 1-.243-.03l-4-1a1 1 0 0 1-.464-1.677l5-5a1 1 0 0 1 .95-.263l4 1a1 1 0 0 1 .464 1.677l-5 5A1 1 0 0 1 46 15Zm-2.044-2.542 1.737.435 3.351-3.351-1.737-.435Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M42 14a1.016 1.016 0 0 1-.267-.036 1 1 0 0 1-.7-.721l-1-4a1 1 0 0 1 .263-.95l5-5a1 1 0 0 1 1.677.464l1 4a1 1 0 0 1-.263.95l-5 5A1 1 0 0 1 42 14Zm.107-4.693.435 1.737 3.351-3.351-.435-1.737ZM15.115 26a1 1 0 0 1-.992-.884A18.429 18.429 0 0 1 14 23 18.009 18.009 0 0 1 39.412 6.592a1 1 0 0 1-.824 1.823A16.008 16.008 0 0 0 16 23a16.423 16.423 0 0 0 .109 1.884 1 1 0 0 1-.877 1.109.918.918 0 0 1-.117.007ZM48.885 26a.918.918 0 0 1-.117-.007 1 1 0 0 1-.877-1.109A16.423 16.423 0 0 0 48 23a15.87 15.87 0 0 0-1.415-6.588 1 1 0 0 1 1.823-.824A17.867 17.867 0 0 1 50 23a18.429 18.429 0 0 1-.123 2.116 1 1 0 0 1-.992.884ZM32 29a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M38.319 33a1 1 0 0 1-.577-1.818 10 10 0 1 0-11.484 0 1 1 0 1 1-1.152 1.636 12 12 0 1 1 13.788 0 1 1 0 0 1-.575.182Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Ready for AI & Analytics</h2>
                            <p>
                              Easily integrate with machine learning tools and
                              data pipelines in the cloud.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Examples of Impact</h2>
                      <ul>
                        <li>
                          <strong>1. </strong> Replaced a local file server with
                          a cloud-based document system accessible globally
                        </li>
                        <li>
                          <strong>2. </strong> Migrated 2 years of business
                          operations into a fully scalable cloud platform
                        </li>
                        <li>
                          <strong>3. </strong> Reduced system downtime by 98%
                          through load balancing and monitoring
                        </li>
                        <li>
                          <strong>4. </strong> Enabled a team to scale from 5 to
                          200 users with no infrastructure changes
                        </li>
                      </ul>
                      <p>
                        <strong>Platforms We Work With</strong>
                      </p>
                      <p className="toolsListWrap">
                        <span>Amazon Web Services (AWS)</span>
                        <span>Microsoft Azure</span>
                        <span>Google Cloud Platform (GCP)</span>
                        <span>DigitalOcean, Linode, and others</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Our Approach</h2>
                      <ul>
                        <li>
                          <strong>1. Assessment & Planning : </strong> Identify
                          your current limitations and future scalability needs.
                        </li>
                        <li>
                          <strong>2. Cloud Setup & Configuration : </strong>
                          Architect a secure, scalable, and optimized cloud
                          infrastructure.
                        </li>
                        <li>
                          <strong>3. Data & App Migration : </strong> Move
                          existing assets to the cloud with minimal disruption.
                        </li>
                        <li>
                          <strong>4. Monitoring & Support : </strong> Set up
                          observability, alerts, and performance tuning.
                        </li>
                        <li>
                          <strong>5. Scale as You Grow : </strong> Continuously
                          optimize as your workload or team expands.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={DedicatedTeamsImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="CommonBtmWrap">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-9">
                    <div className="dataWrap">
                      <h2>Future-Proof Your Business with the Cloud</h2>
                      <p>
                        Whether you're a startup or scaling enterprise, the
                        cloud gives you the foundation to grow fast, securely,
                        and smartly.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "WorkflowAutomation" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Workflow Automation</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="digiTranformWrap commonCotentWrap">
              <div className="container">
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <p>
                        Our company specializes in implementing workflow
                        automation solutions tailored to streamline and optimize
                        our clients' business processes. By automating
                        repetitive and time-consuming tasks, we enable
                        businesses to focus on strategic activities that drive
                        growth and innovation.
                      </p>
                      <h3>Key Aspects of Our Workflow Automation Solutions:</h3>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco2} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Process Analysis and Customization</h2>
                              <p>
                                We begin by thoroughly analyzing the existing
                                workflows of our clients. This allows us to
                                identify bottlenecks and areas that can benefit
                                from automation. We then customize solutions to
                                fit the specific needs and objectives of each
                                client.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WorkflowAutoIco5}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Integration with Existing Systems</h2>
                              <p>
                                Our solutions are designed to seamlessly
                                integrate with our clients' existing IT
                                infrastructure. This integration ensures a
                                smooth transition and maintains data consistency
                                across systems.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco1} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>User-Friendly Interface</h2>
                              <p>
                                We develop automation tools with intuitive user
                                interfaces, making them accessible to all
                                employees, regardless of their technical
                                expertise. This ease of use accelerates adoption
                                and maximizes the benefits of automation.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WorkflowAutoIco6}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Real-Time Data Processing and Reporting</h2>
                              <p>
                                Automated workflows enable real-time data
                                processing, providing instant insights into
                                business operations. Clients can generate
                                automated reports, gaining visibility into
                                process efficiency and performance metrics.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WorkflowAutoIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Error Reduction and Consistency</h2>
                              <p>
                                By automating tasks, we significantly reduce the
                                likelihood of human error, ensuring consistency
                                and accuracy in business processes.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img src={CMSIco5} className="img-fluid" alt="" />
                            </div>
                            <div className="dataWrap">
                              <h2>Scalability</h2>
                              <p>
                                Our solutions are scalable, accommodating the
                                growth and evolving needs of our clients. We
                                ensure that the automated workflows can handle
                                increased loads and complexities without
                                compromising performance.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={CustomerEngIco7}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Compliance and Security</h2>
                              <p>
                                We ensure that our automated workflows adhere to
                                relevant industry standards and regulations.
                                Security protocols are integrated to protect
                                sensitive data and maintain compliance.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WorkflowAutoIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Notification and Alerts</h2>
                              <p>
                                Customizable notifications and alerts keep
                                relevant stakeholders informed about process
                                milestones, exceptions, and required
                                interventions.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WorkflowAutoIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Remote Accessibility</h2>
                              <p>
                                With cloud-based options, our solutions offer
                                remote accessibility, allowing teams to stay
                                connected and productive regardless of their
                                location.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={WorkflowAutoIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Continuous Improvement</h2>
                              <p>
                                We believe in continuous improvement and
                                regularly update our solutions based on client
                                feedback and emerging technological
                                advancements.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={SocialMediaIco8}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Support and Training</h2>
                              <p>
                                Comprehensive training and ongoing support are
                                provided to ensure clients can effectively
                                manage and optimize their automated workflows.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="btmDataWrap">
                      <p>
                        By implementing workflow automation, we empower our
                        clients to enhance operational efficiency, reduce costs,
                        and improve employee satisfaction, leading to overall
                        business excellence and a competitive edge in their
                        respective industries.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap benefitsDigiWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Why Partner with Hummingtec Solutions?</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#6cdc99"
                                      opacity="1"
                                      data-original="#6cdc99"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0h-312.839v-492H74.142v407.853z"
                                    transform="translate(375.349 502)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0h74.142L0 84.147Z"
                                    transform="translate(375.349 417.853)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0c-30.038 17.947-50.151 50.785-50.151 88.314 0 56.78 46.029 102.81 102.809 102.81 56.78 0 102.81-46.03 102.81-102.81 0-12.596-2.266-24.665-6.412-35.818"
                                    transform="translate(203.342 269.815)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0c0-23.597-19.129-42.725-42.726-42.725-23.596 0-42.725 19.128-42.725 42.725 0 23.596 19.129 42.725 42.725 42.725C-19.129 42.725 0 23.596 0 0Z"
                                    transform="translate(298.726 380.647)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v-51.336c-15.404-9.208-33.416-14.496-52.658-14.496-19.242 0-37.254 5.288-52.658 14.496V0c0 9.263 7.5 16.772 16.763 16.772h71.789C-7.501 16.772 0 9.263 0 0Z"
                                    transform="translate(308.658 321.15)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 12.105-19.763 22.536-5.405-15.055-17.62 1.823-23.104L0-57.019l-21.41-8.873 1.823 23.104-15.054 17.62 22.536 5.405z"
                                    transform="translate(153.005 217.922)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 12.105-19.763 22.536-5.405-15.054-17.62 1.822-23.104L0-57.019l-21.409-8.873 1.823 23.104-15.055 17.62 22.536 5.405z"
                                    transform="translate(256 217.922)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 12.104-19.763 22.537-5.405-15.055-17.62 1.823-23.104L0-57.019l-21.41-8.873 1.823 23.104-15.055 17.62 22.537 5.405z"
                                    transform="translate(358.995 217.922)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v0"
                                    transform="translate(347.497 110)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h144.156"
                                    transform="translate(164.502 110)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h275.271"
                                    transform="translate(118.364 65.203)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Expertise and Experience</h2>
                            <p>
                              Our team of digital transformation experts brings
                              a wealth of knowledge and hands-on experience
                              across various industries.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M28.5 24H1c-.6 0-1-.5-1-1v-6.4c0-2.8 2.3-5.2 5.2-5.2h26.7c.6 0 1 .5 1 1s-.5 1-1 1H5.1c-1.7 0-3.1 1.4-3.1 3.1v5.4h26.5c.6 0 1 .5 1 1s-.4 1.1-1 1.1z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M5.1 61c-1.4 0-2.7-.5-3.6-1.5-1-1-1.5-2.3-1.5-3.7V22.9c0-.6.5-1 1-1h27.5c.6 0 1 .5 1 1s-.5 1-1 1H2v31.8c0 .8.3 1.6.9 2.2s1.4.9 2.2.9H52c1.7 0 3.1-1.4 3.1-3.1v-20c0-.6.5-1 1-1s1 .5 1 1v20c0 2.8-2.3 5.2-5.2 5.2H5.1zM9 18.7H6.8c-.6 0-1-.5-1-1s.5-1 1-1H9c.6 0 1 .5 1 1s-.4 1-1 1zM13.9 18.7h-2.2c-.6 0-1-.5-1-1s.5-1 1-1h2.2c.6 0 1 .5 1 1s-.4 1-1 1zM18.8 18.7h-2.2c-.6 0-1-.5-1-1s.5-1 1-1h2.2c.6 0 1 .5 1 1s-.4 1-1 1z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M24.6 42.1H10c-1.7 0-3.1-1.4-3.1-3.1v-8.7c0-1.7 1.4-3.1 3.1-3.1h14.6c1.7 0 3.1 1.4 3.1 3.1V39c0 1.7-1.4 3.1-3.1 3.1zm0-12.9H10c-.6 0-1 .5-1 1V39c0 .6.5 1 1 1h14.6c.6 0 1-.5 1-1v-8.7c0-.6-.5-1.1-1-1.1zM35.1 35.9H34c-.6 0-1-.5-1-1s.5-1 1-1h1.1c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 42.5H34c-.6 0-1-.5-1-1s.5-1 1-1h15.8c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 49.1H7.4c-.6 0-1-.5-1-1s.5-1 1-1h42.4c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 55.7H7.4c-.6 0-1-.5-1-1s.5-1 1-1h42.4c.6 0 1 .5 1 1s-.5 1-1 1zM48.4 36.3h-1.6c-1.3 0-2.4-1-2.6-2.2l-.4-2.5c0-.2-.2-.3-.3-.4-.4-.1-.7-.3-1.1-.4-.2-.1-.3-.1-.5 0l-2 1.5c-1 .7-2.5.6-3.4-.3l-1.2-1.2c-.9-.9-1-2.3-.3-3.4l1.5-2c.1-.2.1-.4 0-.5-.2-.3-.3-.7-.5-1.1-.1-.2-.2-.3-.4-.3l-2.4-.4c-1.3-.2-2.2-1.3-2.2-2.6v-1.7c0-1.3.9-2.4 2.2-2.6l2.4-.4c.2 0 .3-.2.4-.3.1-.4.3-.7.5-1.1.1-.2.1-.4 0-.5l-1.5-2c-.8-1-.6-2.4.2-3.4l1.2-1.2c.9-.9 2.4-1 3.4-.2l1.9 1.5c.2.2.4.1.5 0 .4-.2.7-.3 1.1-.5.2-.1.3-.2.4-.4l.4-2.5C44.4 4 45.5 3 46.8 3h1.6c1.3 0 2.4 1 2.6 2.2l.4 2.5c0 .2.2.3.3.4.4.1.7.3 1.1.4.2.1.3.1.5 0l2-1.5c1-.8 2.5-.6 3.4.3l1.2 1.2c.9.9 1 2.3.3 3.4l-1.5 2c-.1.2-.1.4 0 .5.2.3.3.7.5 1.1.1.2.2.3.4.3l2.4.4c1.3.2 2.2 1.3 2.2 2.6v1.7c0 1.3-.9 2.4-2.2 2.6l-2.4.4c-.2 0-.3.2-.4.3-.1.4-.3.7-.4 1.1-.1.2-.1.4 0 .6l1.5 2c.7 1 .6 2.4-.2 3.4L58.6 32c-.9.9-2.4 1-3.4.2l-1.9-1.5c-.2-.2-.4-.1-.5 0-.4.2-.7.3-1.1.5-.2.1-.3.2-.3.4l-.4 2.5c-.2 1.2-1.3 2.2-2.6 2.2zm-6.3-7.7c.4 0 .8.1 1.1.3.3.1.6.3.9.4.9.3 1.5 1.1 1.7 2l.4 2.5c0 .3.3.5.5.5h1.6c.3 0 .5-.2.5-.4l.4-2.5c.1-.9.8-1.7 1.7-2 .3-.1.6-.2.9-.4.8-.4 1.9-.3 2.7.3l2 1.5c.3.2.5.1.7-.1l1.2-1.2c.2-.2.2-.5 0-.7l-1.5-2c-.6-.8-.7-1.8-.3-2.6.1-.3.3-.6.4-.9.3-.9 1.1-1.6 2-1.7l2.4-.4c.3 0 .4-.3.4-.5V19c0-.3-.2-.5-.4-.5l-2.4-.4c-.9-.1-1.7-.8-2-1.7-.1-.3-.2-.6-.4-.9-.4-.9-.3-1.9.2-2.7l1.5-2c.2-.2.1-.5 0-.7l-1.2-1.2c-.1-.1-.3-.2-.4-.2s-.2 0-.3.1l-1.9 1.5c-.7.6-1.8.7-2.7.3-.3-.1-.6-.3-.9-.4-.9-.3-1.5-1.1-1.7-2l-.4-2.5c0-.3-.3-.5-.5-.5h-1.6c-.3 0-.5.2-.5.4L45.9 8c-.1.9-.8 1.7-1.7 2-.3.1-.6.2-.9.4-.8.4-1.9.3-2.7-.3l-2-1.5c-.3-.3-.5-.1-.7.1l-1.2 1.2c-.2.2-.2.5 0 .7l1.5 2c.5.8.6 1.8.2 2.6-.1.3-.3.6-.4.9-.3.9-1.1 1.6-2 1.7l-2.4.4c-.3 0-.4.3-.4.5v1.7c0 .3.2.5.4.5l2.4.4c.9.1 1.7.8 2 1.7.1.3.2.6.4.9.4.9.3 1.9-.3 2.7l-1.5 2c-.2.2-.1.5 0 .7l1.2 1.2c.2.2.4.3.7.1l2-1.5c.5-.3 1.1-.5 1.6-.5z"
                                  fill="#67a9d5"
                                  opacity="0.45"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M47.6 26.3a6.7 6.7 0 1 1 0-13.4 6.7 6.7 0 0 1 0 13.4zm0-11.3C45 15 43 17.1 43 19.6c0 2.6 2.1 4.6 4.6 4.6s4.6-2.1 4.6-4.6-2.1-4.6-4.6-4.6z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Customized Solutions</h2>
                            <p>
                              We understand that one size does not fit all. Our
                              approach is to tailor solutions that specifically
                              address your unique challenges and opportunities.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="m61.12 38.24-1.941-.48a28 28 0 1 0-54.358 0l-1.941.48a30 30 0 1 1 58.24 0z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M14.027 35.008a1.04 1.04 0 0 1-.651-.227 5.7 5.7 0 0 1-1.619-3.427 1.489 1.489 0 0 1 .747-1.222c.769-.439 2.261-.4 4.742-.19.3.027.546.05.69.056a4.624 4.624 0 0 0 2.108-2.292c.614-2 3.1-4.518 5.546-5.618A8.928 8.928 0 0 1 29.774 21c.819-.825 2.051-4.523 1.413-5.418-.411-.574-1.925-1.16-3.143-1.631-1.882-.728-3.507-1.357-3.979-2.594s.017-3.9.656-6.98c.133-.645.259-1.253.285-1.486a1 1 0 1 1 1.988.22c-.036.328-.153.891-.315 1.671-.287 1.385-1.049 5.064-.744 5.863.181.416 1.905 1.083 2.831 1.441 1.692.654 3.29 1.272 4.047 2.334 1.235 1.727.056 5.108-.74 6.655C31.4 22.388 30.738 23 30 23h-.194a6.823 6.823 0 0 0-3.4.913 9.083 9.083 0 0 0-4.454 4.382C21.391 30.133 19.178 32 18 32c-.156 0-.492-.026-.928-.064a23.945 23.945 0 0 0-3.251-.126 5.636 5.636 0 0 0 .848 1.448.974.974 0 0 1 .135 1.386.989.989 0 0 1-.777.364zM6 36.727a.989.989 0 0 1-.227-.026 7.083 7.083 0 0 1-2.163-.773 1.031 1.031 0 0 1-.477-1.358.974.974 0 0 1 1.312-.47c.049.025.1.054.164.09a5.277 5.277 0 0 0 1.617.558A1 1 0 0 1 6 36.727zM45.78 25.058a3.569 3.569 0 0 1-1.474-.412C43.765 24.389 42 23.438 42 22c0-.348.01-.8.021-1.281.019-.84.044-1.968 0-2.479l-.048-.035A2.307 2.307 0 0 1 41 15.932l.031-.457.369-.275c.183-.137 4.544-3.345 9.047-1.095l.1.057a6.258 6.258 0 0 1 1.519 2.055c.261.445.531.905.74 1.189a1.266 1.266 0 0 1 .2 1.086c-.255.944-1.492 1.611-4.352 2.841-.43.185-.966.415-1.091.492l-.059.036a3.731 3.731 0 0 0-.249 1.2 2.341 2.341 0 0 1-.625 1.712 1.3 1.3 0 0 1-.85.285zM43.057 16.5a1 1 0 0 0 .132.113 1.828 1.828 0 0 1 .8 1.247 24.719 24.719 0 0 1 .03 2.9c-.011.464-.021.9-.021 1.235a3.277 3.277 0 0 0 1.263.89v-.038c.1-.9.227-2.134 1.207-2.7a11.175 11.175 0 0 1 1.39-.652 25.48 25.48 0 0 0 2.973-1.436c-.161-.258-.327-.541-.5-.834a11.809 11.809 0 0 0-.883-1.379c-2.648-1.261-5.348.033-6.391.654zm4.436 5.365-.016.01zM32 47a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM43 61a1 1 0 0 1-1-1v-7a3 3 0 0 0-3-3H25a3 3 0 0 0-3 3v7a1 1 0 0 1-2 0v-7a5.006 5.006 0 0 1 5-5h14a5.006 5.006 0 0 1 5 5v7a1 1 0 0 1-1 1zM12 52a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM1 61a1 1 0 0 1-1-1v-2a5.006 5.006 0 0 1 5-5h13a1 1 0 0 1 0 2H5a3 3 0 0 0-3 3v2a1 1 0 0 1-1 1zM52 52a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM63 61a1 1 0 0 1-1-1v-2a3 3 0 0 0-3-3H46a1 1 0 0 1 0-2h13a5.006 5.006 0 0 1 5 5v2a1 1 0 0 1-1 1z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Collaborative Partnership</h2>
                            <p>
                              We work as an extension of your team, ensuring
                              seamless communication and alignment with your
                              business objectives.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M51.464 41.328A9.234 9.234 0 0 0 48.88 41a9.57 9.57 0 0 0-2.345.331 1 1 0 0 0-.742.967l-.007.998a7.643 7.643 0 0 0-1.131.63.133.133 0 0 1-.1-.016l-.863-.482a1.001 1.001 0 0 0-1.177.148 8.936 8.936 0 0 0-2.482 4.162 1 1 0 0 0 .479 1.131l.9.503a6.813 6.813 0 0 0 0 1.256l-.9.503a1 1 0 0 0-.479 1.13 8.927 8.927 0 0 0 2.477 4.165 1.001 1.001 0 0 0 1.177.149l.868-.485a.139.139 0 0 1 .098-.018 12.114 12.114 0 0 0 1.14.666v.968a1 1 0 0 0 .742.966 9.563 9.563 0 0 0 2.47.328h.113a9.57 9.57 0 0 0 2.345-.331 1 1 0 0 0 .742-.967l.007-.998a7.643 7.643 0 0 0 1.131-.63.133.133 0 0 1 .1.016l.863.483a.998.998 0 0 0 1.177-.15 8.937 8.937 0 0 0 2.482-4.16 1 1 0 0 0-.479-1.132l-.9-.503a6.813 6.813 0 0 0 0-1.256l.9-.503a1 1 0 0 0 .479-1.131 8.933 8.933 0 0 0-2.477-4.164 1.001 1.001 0 0 0-1.177-.149l-.868.485a.148.148 0 0 1-.098.018 12.149 12.149 0 0 0-1.14-.666v-.968a1 1 0 0 0-.742-.966Zm.763 4.257a2.115 2.115 0 0 0 2.192.071l.19-.106a6.923 6.923 0 0 1 1.185 1.974l-.78.435a1 1 0 0 0-.494 1.06 4.968 4.968 0 0 1 0 1.961 1 1 0 0 0 .495 1.06l.779.436a6.937 6.937 0 0 1-1.188 1.972l-.188-.105a2.107 2.107 0 0 0-2.191.072 5.642 5.642 0 0 1-.836.465 2.034 2.034 0 0 0-1.185 1.858v.16a7.186 7.186 0 0 1-1.112.101 7.11 7.11 0 0 1-1.3-.1v-.161a2.034 2.034 0 0 0-1.185-1.858 5.65 5.65 0 0 1-.836-.466 2.111 2.111 0 0 0-2.192-.07l-.19.106a6.919 6.919 0 0 1-1.185-1.974l.78-.436a1 1 0 0 0 .494-1.06 4.968 4.968 0 0 1 0-1.96 1 1 0 0 0-.495-1.06l-.779-.436a6.937 6.937 0 0 1 1.189-1.972l.187.104a2.111 2.111 0 0 0 2.191-.071 5.642 5.642 0 0 1 .836-.465 2.034 2.034 0 0 0 1.185-1.858v-.16a7.186 7.186 0 0 1 1.112-.101 7.559 7.559 0 0 1 1.3.1v.161a2.034 2.034 0 0 0 1.185 1.858 5.601 5.601 0 0 1 .836.465Z"
                                  fill="#e2e283"
                                  opacity="1"
                                  data-original="#e2e283"
                                ></path>
                                <path
                                  d="M45 50a4 4 0 1 0 4-4 4.005 4.005 0 0 0-4 4Zm6 0a2 2 0 1 1-2-2 2.002 2.002 0 0 1 2 2ZM2 6v51a2.002 2.002 0 0 0 2 2h32v-2H4V6h14v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6h14v29h2V6a2.002 2.002 0 0 0-2-2H34a3.003 3.003 0 0 0-3-3H21a3.003 3.003 0 0 0-3 3H4a2.002 2.002 0 0 0-2 2Zm18-2a1.001 1.001 0 0 1 1-1h10a1.001 1.001 0 0 1 1 1v3H20Z"
                                  fill="#e2e283"
                                  opacity="1"
                                  data-original="#e2e283"
                                ></path>
                                <path
                                  d="M15 46a1 1 0 0 0 1-1V26a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1Zm-4-19h3v17h-3ZM24 46a1 1 0 0 0 1-1V23a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1Zm-4-22h3v20h-3ZM33 46a1 1 0 0 0 1-1V28a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1Zm-4-17h3v15h-3ZM43 38V23a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v19h2V24h3v14Z"
                                  fill="#e2e283"
                                  opacity="0.45"
                                  data-original="#e2e283"
                                ></path>
                                <path
                                  d="m43.553 13.105-13.499 6.75-7.524-4.703a1.002 1.002 0 0 0-.881-.088l-16 6 .702 1.872L21.89 17.11l7.581 4.738a1.005 1.005 0 0 0 .977.047l14-7ZM6 48h29v2H6zM62 50q0-.547-.044-1.083l-1.994.165Q60 49.537 60 50q0 .464-.038.917l1.994.165Q62 50.548 62 50ZM49 37a12.993 12.993 0 0 0-12.59 9.75l1.936.5a11.004 11.004 0 0 1 21.308 0l1.936-.5A12.993 12.993 0 0 0 49 37ZM38.038 50.917Q38 50.463 38 50q0-.464.038-.917l-1.994-.165Q36 49.452 36 50q0 .547.044 1.083ZM49 63a12.993 12.993 0 0 0 12.59-9.75l-1.936-.5a11.004 11.004 0 0 1-21.308 0l-1.936.5A12.993 12.993 0 0 0 49 63Z"
                                  fill="#e2e283"
                                  opacity="0.45"
                                  data-original="#e2e283"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Outcome-Focused</h2>
                            <p>
                              Your success is our success. We're committed to
                              delivering measurable results that impact your
                              bottom line.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="whyHumingtecSec">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Transform Your Business with Hummingtec Solutions</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="dataWrap">
                      <p>
                        Embrace the digital future confidently with Hummingtec
                        Solutions. Our digital transformation services are your
                        gateway to becoming a more agile, efficient, and
                        innovative organization. Ready to embark on a
                        transformative journey? Contact us today to explore how
                        we can elevate your business in the digital age.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
      <Footer></Footer>
    </>
  );
};
export default DigitalTransformationDtls;
